import React, { useEffect, useMemo, useState, useRef, Fragment } from 'react';
import { BarChart3, Users, Calendar, DollarSign, TrendingUp, Clock, Filter, Search, Plus, MoreVertical, Eye, Edit, Trash2, CheckCircle2, AlertTriangle, ArrowRight, Download, FileText, Mail, MessageSquare, Star, Activity, Zap, Award, Crown, ArrowUpRight, ArrowDownRight, Send, MailOpen, ShoppingCart, UserCheck, LayoutList, EyeOff, Globe, Settings, Pin, BookOpen, MousePointer, ChevronRight, X, Play, Pause, Megaphone, Layers, RefreshCw, ExternalLink, Timer, Target } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
import { Pagination } from '../ui/Pagination';
import { AdSlot } from '../ads/AdSlot';
import { ALL_AD_SLOTS } from '../ads/adData';
import { AdQueueManager } from './AdQueueManager';
import { FeaturedCoursesManager } from './FeaturedCoursesManager';
import { FeaturedAstrologersManager } from './FeaturedAstrologersManager';
import { EmailCampaignsManager } from './EmailCampaignsManager';
import { AdAnalyticsDashboard } from './AdAnalyticsDashboard';
interface AdminAdvertisingFullManagerProps {
  adRequests: any[];
  adPlacements: any[];
  astrologers: any[];
  setActiveTab: (tab: string) => void;
  setDetailPanel: (panel: any) => void;
  success: (msg: string) => void;
}
// --- MOCK DATA ---
const mockPlacements = [{
  id: 'PLC-101',
  slot: 'SLOT-01',
  slotName: 'Главная TOP баннер',
  type: 'Banner',
  object: 'AstroSchool',
  objectType: 'Курс',
  advertiser: 'AstroSchool Inc.',
  periodStart: '01.03.2026',
  periodEnd: '31.03.2026',
  price: 45000,
  impressionsPlan: 50000,
  impressionsFact: 38420,
  clicks: 1245,
  ctr: '3.24%',
  status: 'active',
  payment: 'paid',
  queuePosition: null,
  timer: 'Осталось 15 дней',
  daysLeft: 15,
  statusReason: 'running',
  priority: 8,
  autoRenew: true,
  slotCapacity: {
    limit: 1,
    active: 1,
    queued: 2
  }
}, {
  id: 'PLC-102',
  slot: 'SLOT-04',
  slotName: 'Топ каталога',
  type: 'Pinned astrologer',
  object: 'Мария Звёздная',
  objectType: 'Астролог',
  advertiser: 'Мария Звёздная',
  periodStart: '10.03.2026',
  periodEnd: '10.04.2026',
  price: 15000,
  impressionsPlan: 20000,
  impressionsFact: 8200,
  clicks: 412,
  ctr: '5.02%',
  status: 'active',
  payment: 'paid',
  queuePosition: null,
  timer: 'Осталось 25 дней',
  daysLeft: 25,
  statusReason: 'running',
  priority: 7,
  autoRenew: false,
  slotCapacity: {
    limit: 3,
    active: 2,
    queued: 1
  }
}, {
  id: 'PLC-103',
  slot: 'SLOT-05',
  slotName: 'Email дайджест',
  type: 'Email',
  object: 'Весенний прогноз',
  objectType: 'Статья',
  advertiser: 'Редакция',
  periodStart: '15.03.2026',
  periodEnd: '15.03.2026',
  price: 8000,
  impressionsPlan: 12000,
  impressionsFact: 11800,
  clicks: 890,
  ctr: '7.54%',
  status: 'completed',
  payment: 'paid',
  queuePosition: null,
  timer: 'Завершено',
  daysLeft: 0,
  statusReason: 'completed_naturally',
  priority: 5,
  autoRenew: false,
  slotCapacity: {
    limit: 1,
    active: 0,
    queued: 0
  }
}, {
  id: 'PLC-104',
  slot: 'SLOT-01',
  slotName: 'Главная TOP баннер',
  type: 'Promo',
  object: 'Курс Таро',
  objectType: 'Курс',
  advertiser: 'TaroMaster',
  periodStart: '20.03.2026',
  periodEnd: '20.04.2026',
  price: 25000,
  impressionsPlan: 30000,
  impressionsFact: 0,
  clicks: 0,
  ctr: '0%',
  status: 'scheduled',
  payment: 'pending',
  queuePosition: null,
  timer: 'Старт через 4 дня',
  daysLeft: 4,
  statusReason: 'waiting_start_date',
  priority: 6,
  autoRenew: true,
  slotCapacity: {
    limit: 1,
    active: 1,
    queued: 2
  }
}, {
  id: 'PLC-105',
  slot: 'SLOT-03',
  slotName: 'Внутри статьи',
  type: 'Banner',
  object: 'Ретроградный Меркурий',
  objectType: 'Баннер',
  advertiser: 'MercuryApp',
  periodStart: '01.03.2026',
  periodEnd: '15.03.2026',
  price: 12000,
  impressionsPlan: 15000,
  impressionsFact: 14800,
  clicks: 620,
  ctr: '4.19%',
  status: 'completed',
  payment: 'paid',
  queuePosition: null,
  timer: 'Завершено',
  daysLeft: 0,
  statusReason: 'impression_limit_reached',
  priority: 4,
  autoRenew: false,
  slotCapacity: {
    limit: 3,
    active: 1,
    queued: 0
  }
}, {
  id: 'PLC-106',
  slot: 'SLOT-01',
  slotName: 'Главная TOP баннер',
  type: 'Banner',
  object: 'AI Astrology',
  objectType: 'Сервис',
  advertiser: 'AI Tech',
  periodStart: '01.04.2026',
  periodEnd: '30.04.2026',
  price: 50000,
  impressionsPlan: 60000,
  impressionsFact: 0,
  clicks: 0,
  ctr: '0%',
  status: 'queued',
  payment: 'paid',
  queuePosition: 1,
  timer: 'В очереди',
  daysLeft: 30,
  priority: 9,
  queueType: 'priority',
  startType: 'immediate',
  paymentStatus: 'paid',
  slotFreeDate: '31.03.2026',
  slotFreeTimer: '2д 14ч',
  conflict: false,
  conflictReason: null,
  deadline: '15.04.2026',
  fastTrack: true,
  statusReason: 'slot_full',
  autoRenew: true,
  slotCapacity: {
    limit: 1,
    active: 1,
    queued: 2
  }
}, {
  id: 'PLC-107',
  slot: 'SLOT-01',
  slotName: 'Главная TOP баннер',
  type: 'Native article',
  object: 'Tarot School',
  objectType: 'Курс',
  advertiser: 'Tarot School',
  periodStart: '01.05.2026',
  periodEnd: '31.05.2026',
  price: 40000,
  impressionsPlan: 45000,
  impressionsFact: 0,
  clicks: 0,
  ctr: '0%',
  status: 'queued',
  payment: 'pending',
  queuePosition: 2,
  timer: 'В очереди',
  daysLeft: 60,
  priority: 5,
  queueType: 'strict',
  startType: 'fixed',
  paymentStatus: 'pending',
  slotFreeDate: '30.04.2026',
  slotFreeTimer: '32д',
  conflict: true,
  conflictReason: 'Пересечение дат с PLC-106',
  deadline: '20.05.2026',
  fastTrack: false,
  statusReason: 'slot_full',
  autoRenew: false,
  slotCapacity: {
    limit: 1,
    active: 1,
    queued: 2
  }
}, {
  id: 'PLC-108',
  slot: 'SLOT-02',
  slotName: 'Сайдбар каталога',
  type: 'Banner',
  object: 'MoonApp',
  objectType: 'Сервис',
  advertiser: 'MoonApp Inc.',
  periodStart: '05.03.2026',
  periodEnd: '05.04.2026',
  price: 20000,
  impressionsPlan: 25000,
  impressionsFact: 8500,
  clicks: 210,
  ctr: '2.47%',
  status: 'paused',
  payment: 'paid',
  queuePosition: null,
  timer: 'Осталось 2 дня',
  daysLeft: 2,
  statusReason: 'manual_pause',
  priority: 3,
  autoRenew: false,
  slotCapacity: {
    limit: 2,
    active: 0,
    queued: 0
  }
}, {
  id: 'PLC-109',
  slot: 'SLOT-04',
  slotName: 'Топ каталога',
  type: 'Pinned astrologer',
  object: 'Виктория Небесная',
  objectType: 'Астролог',
  advertiser: 'Виктория Небесная',
  periodStart: '01.04.2026',
  periodEnd: '01.05.2026',
  price: 15000,
  impressionsPlan: 20000,
  impressionsFact: 0,
  clicks: 0,
  ctr: '0%',
  status: 'queued',
  payment: 'paid',
  queuePosition: 1,
  timer: 'В очереди',
  daysLeft: 15,
  priority: 7,
  queueType: 'hybrid',
  startType: 'immediate',
  paymentStatus: 'paid',
  slotFreeDate: '10.04.2026',
  slotFreeTimer: '12д 8ч',
  conflict: false,
  conflictReason: null,
  deadline: '15.04.2026',
  fastTrack: false,
  statusReason: 'slot_full',
  autoRenew: true,
  slotCapacity: {
    limit: 3,
    active: 2,
    queued: 1
  }
}, {
  id: 'PLC-110',
  slot: 'SLOT-06',
  slotName: 'Гороскоп — баннер',
  type: 'Native',
  object: 'ZodiacApp',
  objectType: 'Сервис',
  advertiser: 'ZodiacApp Inc.',
  periodStart: '01.03.2026',
  periodEnd: '15.03.2026',
  price: 32400,
  impressionsPlan: 100000,
  impressionsFact: 45000,
  clicks: 2025,
  ctr: '4.50%',
  status: 'active',
  payment: 'paid',
  queuePosition: null,
  timer: 'Осталось 5 дней',
  daysLeft: 5,
  statusReason: 'running',
  priority: 6,
  autoRenew: true,
  slotCapacity: {
    limit: 2,
    active: 1,
    queued: 0
  }
}, {
  id: 'PLC-111',
  slot: 'SLOT-08',
  slotName: 'Бесплатная карта — после результата',
  type: 'Native',
  object: 'AstroReport Pro',
  objectType: 'Сервис',
  advertiser: 'Astriqo',
  periodStart: '05.03.2026',
  periodEnd: '05.04.2026',
  price: 48400,
  impressionsPlan: 50000,
  impressionsFact: 12000,
  clicks: 720,
  ctr: '6.00%',
  status: 'active',
  payment: 'paid',
  queuePosition: null,
  timer: 'Осталось 19 дней',
  daysLeft: 19,
  statusReason: 'running',
  priority: 8,
  autoRenew: true,
  slotCapacity: {
    limit: 1,
    active: 1,
    queued: 0
  }
}, {
  id: 'PLC-112',
  slot: 'SLOT-15',
  slotName: 'Главная — после отзывов',
  type: 'Banner',
  object: 'StarMap',
  objectType: 'Сервис',
  advertiser: 'StarMap Ltd.',
  periodStart: '20.03.2026',
  periodEnd: '03.04.2026',
  price: 59500,
  impressionsPlan: 400000,
  impressionsFact: 0,
  clicks: 0,
  ctr: '0%',
  status: 'queued',
  payment: 'paid',
  queuePosition: 1,
  timer: 'В очереди',
  daysLeft: 14,
  priority: 7,
  queueType: 'priority',
  startType: 'immediate',
  paymentStatus: 'paid',
  slotFreeDate: '19.03.2026',
  slotFreeTimer: '2д 4ч',
  conflict: false,
  conflictReason: null,
  deadline: '25.03.2026',
  fastTrack: false,
  statusReason: 'slot_full',
  autoRenew: false,
  slotCapacity: {
    limit: 1,
    active: 0,
    queued: 1
  }
}, {
  id: 'PLC-113',
  slot: 'SLOT-11',
  slotName: 'Лунный календарь — баннер',
  type: 'Banner',
  object: 'MoonPhase App',
  objectType: 'Приложение',
  advertiser: 'MoonPhase Inc.',
  periodStart: '10.03.2026',
  periodEnd: '24.03.2026',
  price: 22400,
  impressionsPlan: 100000,
  impressionsFact: 30000,
  clicks: 900,
  ctr: '3.00%',
  status: 'active',
  payment: 'paid',
  queuePosition: null,
  timer: 'Осталось 8 дней',
  daysLeft: 8,
  statusReason: 'running',
  priority: 5,
  autoRenew: true,
  slotCapacity: {
    limit: 2,
    active: 1,
    queued: 0
  }
}, {
  id: 'PLC-114',
  slot: 'SLOT-17',
  slotName: 'Результат отчёта — апсейл',
  type: 'Native',
  object: 'Premium Consult',
  objectType: 'Услуга',
  advertiser: 'Astriqo',
  periodStart: '01.04.2026',
  periodEnd: '01.05.2026',
  price: 62500,
  impressionsPlan: 15000,
  impressionsFact: 0,
  clicks: 0,
  ctr: '0%',
  status: 'scheduled',
  payment: 'pending',
  queuePosition: null,
  timer: 'Старт через 15 дней',
  daysLeft: 15,
  statusReason: 'waiting_start_date',
  priority: 9,
  autoRenew: false,
  slotCapacity: {
    limit: 1,
    active: 0,
    queued: 5
  }
}, {
  id: 'PLC-115',
  slot: 'SLOT-18',
  slotName: 'Мобильный sticky баннер',
  type: 'Banner',
  object: 'Astriqo Premium',
  objectType: 'Подписка',
  advertiser: 'Astriqo',
  periodStart: '13.03.2026',
  periodEnd: '20.03.2026',
  price: 60000,
  impressionsPlan: 1000000,
  impressionsFact: 450000,
  clicks: 4500,
  ctr: '1.00%',
  status: 'active',
  payment: 'paid',
  queuePosition: null,
  timer: 'Осталось 3 дня',
  daysLeft: 3,
  statusReason: 'running',
  priority: 10,
  autoRenew: true,
  slotCapacity: {
    limit: 1,
    active: 1,
    queued: 0
  }
}];
const mockSlots = [{
  id: 'SLOT-01',
  name: 'Главная TOP баннер',
  page: 'Главная',
  type: 'Banner',
  size: '1140×250',
  basePrice: 50000,
  limit: 1,
  active: 1,
  queued: 2,
  rotation: 'queue',
  duration: 30,
  timerType: 'fixed',
  priority: 10,
  frequencyCap: {
    maxImpressions: 50000,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 2.0,
  autoRenewal: true,
  revenue: 135000,
  fillRate: 100,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 1250400,
  clicks: 45200,
  ctr: '3.61%',
  slotReleaseAt: '2026-03-31T23:59:59',
  slotReleaseTimer: '14д 12ч',
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 45,
  events: [{
    type: 'onImpressionLimitReached',
    time: '10:45',
    description: 'Баннер #452 достиг лимита показов'
  }, {
    type: 'onSlotFreed',
    time: '10:45',
    description: 'Слот освободился'
  }, {
    type: 'onQueueUpdated',
    time: '10:46',
    description: 'Активирован баннер #489 из очереди'
  }]
}, {
  id: 'SLOT-02',
  name: 'Сайдбар каталога',
  page: 'Каталог',
  type: 'Banner',
  size: '300×600',
  basePrice: 20000,
  limit: 2,
  active: 0,
  queued: 0,
  rotation: 'random',
  duration: 14,
  timerType: 'rolling',
  priority: 5,
  frequencyCap: {
    maxImpressions: 25000,
    maxClicks: 1000
  },
  paymentType: 'CPM',
  status: 'active',
  geo: ['RU', 'EU'],
  demandCoefficient: 0.7,
  autoRenewal: false,
  revenue: 0,
  fillRate: 0,
  refreshLogic: 'interval',
  refreshInterval: 30,
  fallback: 'hide',
  health: 'empty',
  impressions: 0,
  clicks: 0,
  ctr: '0%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 32,
  events: [{
    type: 'onAdExpired',
    time: 'Вчера 23:59',
    description: 'Истёк срок размещения #399'
  }, {
    type: 'onSlotFreed',
    time: 'Вчера 23:59',
    description: 'Слот пуст, включен fallback (hide)'
  }]
}, {
  id: 'SLOT-03',
  name: 'Внутри статьи',
  page: 'Блог',
  type: 'Native',
  size: '728×90',
  basePrice: 12000,
  limit: 3,
  active: 1,
  queued: 0,
  rotation: 'weighted',
  duration: 7,
  timerType: 'fixed',
  priority: 3,
  frequencyCap: {
    maxImpressions: 15000,
    maxClicks: null
  },
  paymentType: 'CPC',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 0.8,
  autoRenewal: true,
  revenue: 12000,
  fillRate: 33,
  refreshLogic: 'every_request',
  refreshInterval: null,
  fallback: 'placeholder',
  health: 'healthy',
  impressions: 450000,
  clicks: 12500,
  ctr: '2.77%',
  slotReleaseAt: '2026-03-20T12:00:00',
  slotReleaseTimer: '3д 4ч',
  cacheEnabled: true,
  cdnEnabled: false,
  responseTime: 85,
  events: [{
    type: 'onPaymentSuccess',
    time: 'Сегодня 09:15',
    description: 'Оплата 12,000₽ получена'
  }]
}, {
  id: 'SLOT-04',
  name: 'Топ каталога',
  page: 'Каталог',
  type: 'Pinned',
  size: 'Карточка',
  basePrice: 15000,
  limit: 3,
  active: 3,
  queued: 15,
  rotation: 'static',
  duration: 30,
  timerType: 'fixed',
  priority: 8,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 2.5,
  autoRenewal: true,
  revenue: 45000,
  fillRate: 100,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'overloaded',
  impressions: 890000,
  clicks: 67000,
  ctr: '7.52%',
  slotReleaseAt: '2026-04-10T00:00:00',
  slotReleaseTimer: '24д 1ч',
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 40,
  events: [{
    type: 'onQueueUpdated',
    time: '14:20',
    description: 'Добавлено новое размещение в очередь (#15)'
  }, {
    type: 'SystemAlert',
    time: '14:20',
    description: 'Слот перегружен (очередь > 10)'
  }]
}, {
  id: 'SLOT-05',
  name: 'Email дайджест',
  page: 'Email',
  type: 'Email',
  size: 'Блок',
  basePrice: 8000,
  limit: 1,
  active: 0,
  queued: 0,
  rotation: 'static',
  duration: 1,
  timerType: 'fixed',
  priority: 2,
  frequencyCap: {
    maxImpressions: 12000,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'paused',
  geo: ['RU', 'US'],
  demandCoefficient: 0.5,
  autoRenewal: false,
  revenue: 8000,
  fillRate: 0,
  refreshLogic: 'every_request',
  refreshInterval: null,
  fallback: 'hide',
  health: 'paused',
  impressions: 0,
  clicks: 0,
  ctr: '0%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: false,
  cdnEnabled: false,
  responseTime: 0,
  events: [{
    type: 'AdminAction',
    time: '3 дня назад',
    description: 'Слот поставлен на паузу администратором'
  }]
}, {
  id: 'SLOT-06',
  name: 'Гороскоп — баннер',
  page: 'Гороскоп',
  type: 'Native',
  size: '728×90',
  basePrice: 18000,
  limit: 2,
  active: 1,
  queued: 0,
  rotation: 'weighted',
  duration: 14,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 1.8,
  autoRenewal: true,
  revenue: 36000,
  fillRate: 65,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 320000,
  clicks: 14400,
  ctr: '4.50%',
  slotReleaseAt: '2026-04-15T00:00:00',
  slotReleaseTimer: '29д 1ч',
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 35,
  events: []
}, {
  id: 'SLOT-07',
  name: 'Гороскоп — сайдбар',
  page: 'Гороскоп',
  type: 'Banner',
  size: '300×250',
  basePrice: 12000,
  limit: 1,
  active: 0,
  queued: 0,
  rotation: 'random',
  duration: 7,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 1.5,
  autoRenewal: true,
  revenue: 24000,
  fillRate: 80,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 280000,
  clicks: 8400,
  ctr: '3.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 30,
  events: []
}, {
  id: 'SLOT-08',
  name: 'Бесплатная карта — после результата',
  page: 'Бесплатная карта',
  type: 'Native',
  size: '728×90',
  basePrice: 22000,
  limit: 1,
  active: 1,
  queued: 0,
  rotation: 'queue',
  duration: 30,
  timerType: 'fixed',
  priority: 8,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 2.2,
  autoRenewal: true,
  revenue: 44000,
  fillRate: 100,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 95000,
  clicks: 5700,
  ctr: '6.00%',
  slotReleaseAt: '2026-04-05T00:00:00',
  slotReleaseTimer: '19д 1ч',
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 40,
  events: []
}, {
  id: 'SLOT-09',
  name: 'Блог — сайдбар',
  page: 'Блог',
  type: 'Banner',
  size: '300×600',
  basePrice: 15000,
  limit: 1,
  active: 0,
  queued: 0,
  rotation: 'random',
  duration: 14,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU', 'EU'],
  demandCoefficient: 1.2,
  autoRenewal: true,
  revenue: 15000,
  fillRate: 50,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 180000,
  clicks: 5400,
  ctr: '3.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 32,
  events: []
}, {
  id: 'SLOT-10',
  name: 'Совместимость — после результата',
  page: 'Совместимость',
  type: 'Native',
  size: '728×90',
  basePrice: 20000,
  limit: 1,
  active: 0,
  queued: 0,
  rotation: 'queue',
  duration: 30,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 2.0,
  autoRenewal: true,
  revenue: 40000,
  fillRate: 85,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 75000,
  clicks: 5250,
  ctr: '7.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 38,
  events: []
}, {
  id: 'SLOT-11',
  name: 'Лунный календарь — баннер',
  page: 'Лунный календарь',
  type: 'Banner',
  size: '728×90',
  basePrice: 14000,
  limit: 2,
  active: 1,
  queued: 0,
  rotation: 'weighted',
  duration: 14,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 1.6,
  autoRenewal: true,
  revenue: 28000,
  fillRate: 70,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 210000,
  clicks: 6300,
  ctr: '3.00%',
  slotReleaseAt: '2026-03-25T00:00:00',
  slotReleaseTimer: '8д 1ч',
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 33,
  events: []
}, {
  id: 'SLOT-12',
  name: 'Профиль астролога — рекомендации',
  page: 'Профиль астролога',
  type: 'Pinned',
  size: 'Карточка',
  basePrice: 10000,
  limit: 2,
  active: 0,
  queued: 0,
  rotation: 'static',
  duration: 30,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 1.3,
  autoRenewal: true,
  revenue: 20000,
  fillRate: 60,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 45000,
  clicks: 3600,
  ctr: '8.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 25,
  events: []
}, {
  id: 'SLOT-13',
  name: 'Страница услуг — кросс-продажи',
  page: 'Услуги',
  type: 'Native',
  size: 'Карточка',
  basePrice: 16000,
  limit: 3,
  active: 0,
  queued: 0,
  rotation: 'weighted',
  duration: 30,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 1.4,
  autoRenewal: true,
  revenue: 48000,
  fillRate: 55,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 60000,
  clicks: 4200,
  ctr: '7.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 28,
  events: []
}, {
  id: 'SLOT-14',
  name: 'FAQ — баннер',
  page: 'FAQ',
  type: 'Banner',
  size: '728×90',
  basePrice: 8000,
  limit: 1,
  active: 0,
  queued: 0,
  rotation: 'random',
  duration: 30,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU', 'EU'],
  demandCoefficient: 0.6,
  autoRenewal: true,
  revenue: 8000,
  fillRate: 30,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'hide',
  health: 'empty',
  impressions: 25000,
  clicks: 500,
  ctr: '2.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 20,
  events: []
}, {
  id: 'SLOT-15',
  name: 'Главная — после отзывов',
  page: 'Главная',
  type: 'Banner',
  size: '1140×250',
  basePrice: 35000,
  limit: 1,
  active: 0,
  queued: 1,
  rotation: 'queue',
  duration: 14,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 1.7,
  autoRenewal: true,
  revenue: 70000,
  fillRate: 90,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 850000,
  clicks: 25500,
  ctr: '3.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 42,
  events: []
}, {
  id: 'SLOT-16',
  name: 'Каталог — между карточками',
  page: 'Каталог',
  type: 'Native',
  size: 'Карточка',
  basePrice: 12000,
  limit: 2,
  active: 0,
  queued: 0,
  rotation: 'weighted',
  duration: 14,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 1.5,
  autoRenewal: true,
  revenue: 24000,
  fillRate: 75,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 420000,
  clicks: 16800,
  ctr: '4.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 36,
  events: []
}, {
  id: 'SLOT-17',
  name: 'Результат отчёта — апсейл',
  page: 'Отчёт',
  type: 'Native',
  size: 'Карточка',
  basePrice: 25000,
  limit: 1,
  active: 0,
  queued: 5,
  rotation: 'static',
  duration: 30,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU'],
  demandCoefficient: 2.5,
  autoRenewal: true,
  revenue: 50000,
  fillRate: 100,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'overloaded',
  impressions: 35000,
  clicks: 3500,
  ctr: '10.00%',
  slotReleaseAt: null,
  slotReleaseTimer: null,
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 45,
  events: []
}, {
  id: 'SLOT-18',
  name: 'Мобильный sticky баннер',
  page: 'Все страницы',
  type: 'Banner',
  size: '320×50',
  basePrice: 30000,
  limit: 1,
  active: 1,
  queued: 0,
  rotation: 'queue',
  duration: 7,
  timerType: 'fixed',
  priority: 5,
  frequencyCap: {
    maxImpressions: null,
    maxClicks: null
  },
  paymentType: 'fixed',
  status: 'active',
  geo: ['RU', 'EU', 'US'],
  demandCoefficient: 2.0,
  autoRenewal: true,
  revenue: 120000,
  fillRate: 100,
  refreshLogic: 'every_session',
  refreshInterval: null,
  fallback: 'internal_banner',
  health: 'healthy',
  impressions: 2500000,
  clicks: 25000,
  ctr: '1.00%',
  slotReleaseAt: '2026-03-20T00:00:00',
  slotReleaseTimer: '3д 1ч',
  cacheEnabled: true,
  cdnEnabled: true,
  responseTime: 22,
  events: []
}];
const mockFeaturedAstrologers = [{
  id: 'FA-01',
  astrologer: 'Мария Звёздная',
  advertiser: 'Мария Звёздная',
  advertiserType: 'astrologer',
  slot: 'Каталог астрологов - TOP',
  position: 'TOP 1',
  periodStart: '10.03.2026',
  periodEnd: '10.04.2026',
  price: 15000,
  impressions: 8200,
  clicks: 412,
  bookings: 45,
  status: 'active',
  paymentStatus: 'paid',
  paymentId: 'PAY-9012-A',
  invoiceId: 'INV-2026-03-10',
  queuePosition: null,
  creatives: [{
    id: 'CR-1',
    name: 'Фото с картами Таро',
    ctr: '5.02%',
    cr: '10.9%'
  }, {
    id: 'CR-2',
    name: 'Классический портрет',
    ctr: '3.8%',
    cr: '8.5%'
  }]
}, {
  id: 'FA-02',
  astrologer: 'Алексей Лунный',
  advertiser: 'Агентство "АстроПро"',
  advertiserType: 'external',
  slot: 'Главная страница - Рекомендуем',
  position: 'TOP 2',
  periodStart: '01.03.2026',
  periodEnd: '31.03.2026',
  price: 12000,
  impressions: 22100,
  clicks: 1050,
  bookings: 82,
  status: 'active',
  paymentStatus: 'paid',
  paymentId: 'PAY-9013-B',
  invoiceId: 'INV-2026-03-01',
  queuePosition: null,
  creatives: [{
    id: 'CR-3',
    name: 'Стандартная карточка',
    ctr: '4.75%',
    cr: '7.8%'
  }]
}, {
  id: 'FA-03',
  astrologer: 'Ольга Солнцева',
  advertiser: 'Ольга Солнцева',
  advertiserType: 'astrologer',
  slot: 'Каталог астрологов - TOP',
  position: 'TOP 3',
  periodStart: '15.03.2026',
  periodEnd: '15.04.2026',
  price: 10000,
  impressions: 0,
  clicks: 0,
  bookings: 0,
  status: 'queued',
  paymentStatus: 'pending',
  paymentId: null,
  invoiceId: 'INV-2026-03-12',
  queuePosition: 1,
  expectedStartAt: '15.03.2026',
  waitTime: '3 дня',
  creatives: []
}];
const mockFeaturedCourses = [{
  id: 'FC-01',
  course: 'Основы натальной карты',
  advertiser: 'АстроШкола "Звезда"',
  advertiserType: 'external',
  slot: 'Главная страница - TOP',
  position: 'TOP 1',
  periodStart: '01.03.2026',
  periodEnd: '31.03.2026',
  price: 25000,
  impressions: 15400,
  clicks: 850,
  purchases: 120,
  status: 'active',
  paymentStatus: 'paid',
  paymentId: 'PAY-8821-A',
  invoiceId: 'INV-2026-03-01',
  queuePosition: null,
  creatives: [{
    id: 'CR-1',
    name: 'Баннер А (Синий)',
    ctr: '5.8%',
    cr: '14.5%'
  }, {
    id: 'CR-2',
    name: 'Баннер Б (Фиолетовый)',
    ctr: '4.2%',
    cr: '12.1%'
  }]
}, {
  id: 'FC-02',
  course: 'Таро для начинающих',
  advertiser: 'Елена Миронова',
  advertiserType: 'astrologer',
  slot: 'Каталог курсов - Сайдбар',
  position: 'TOP 2',
  periodStart: '10.03.2026',
  periodEnd: '10.04.2026',
  price: 18000,
  impressions: 12300,
  clicks: 420,
  purchases: 45,
  status: 'active',
  paymentStatus: 'paid',
  paymentId: 'PAY-8822-B',
  invoiceId: 'INV-2026-03-10',
  queuePosition: null,
  creatives: [{
    id: 'CR-3',
    name: 'Стандартный баннер',
    ctr: '3.4%',
    cr: '10.7%'
  }]
}, {
  id: 'FC-03',
  course: 'Прогнозирование событий',
  advertiser: 'Институт Астрологии',
  advertiserType: 'external',
  slot: 'Главная страница - TOP',
  position: 'TOP 3',
  periodStart: '01.04.2026',
  periodEnd: '30.04.2026',
  price: 15000,
  impressions: 0,
  clicks: 0,
  purchases: 0,
  status: 'queued',
  paymentStatus: 'pending',
  paymentId: null,
  invoiceId: 'INV-2026-03-15',
  queuePosition: 1,
  expectedStartAt: '01.04.2026',
  waitTime: '14 дней',
  creatives: []
}];
const mockEmailCampaigns = [{
  id: 'EC-201',
  name: 'Весенний прогноз',
  date: '15.03.2026',
  sent: '45,000',
  openRate: '34.2%',
  ctr: '7.5%',
  conversions: 340,
  revenue: 450000,
  status: 'sent'
}, {
  id: 'EC-202',
  name: 'Промо: скидка 20%',
  date: '20.03.2026',
  sent: '—',
  openRate: '—',
  ctr: '—',
  conversions: 0,
  revenue: 0,
  status: 'scheduled'
}, {
  id: 'EC-203',
  name: 'Новый астролог',
  date: '12.03.2026',
  sent: '12,400',
  openRate: '28.5%',
  ctr: '5.3%',
  conversions: 85,
  revenue: 125000,
  status: 'sent'
}];
const calendarData = [{
  slot: 'Главная TOP',
  placements: [{
    name: 'AstroSchool',
    start: 1,
    end: 31,
    month: 'Март',
    color: 'bg-emerald-400'
  }, {
    name: 'Курс Таро',
    start: 20,
    end: 30,
    month: 'Март-Апр',
    color: 'bg-amber-400'
  }, {
    name: 'AI Astrology',
    start: 1,
    end: 30,
    month: 'Апрель',
    color: 'bg-indigo-400'
  }, {
    name: 'Tarot School',
    start: 1,
    end: 31,
    month: 'Май',
    color: 'bg-indigo-400'
  }]
}, {
  slot: 'Сайдбар',
  placements: [{
    name: 'MoonApp',
    start: 5,
    end: 31,
    month: 'Март-Апр',
    color: 'bg-slate-400'
  }]
}, {
  slot: 'Блог',
  placements: [{
    name: 'Меркурий',
    start: 1,
    end: 15,
    month: 'Март',
    color: 'bg-slate-400'
  }]
}];
// --- CONFIGS ---
const placementStatusConfig: Record<string, {
  label: string;
  variant: 'success' | 'warning' | 'error' | 'neutral' | 'pro';
}> = {
  active: {
    label: 'Активно',
    variant: 'success'
  },
  queued: {
    label: 'В очереди',
    variant: 'pro'
  },
  scheduled: {
    label: 'Запланировано',
    variant: 'warning'
  },
  completed: {
    label: 'Завершено',
    variant: 'neutral'
  },
  paused: {
    label: 'Остановлено',
    variant: 'error'
  }
};
const placementTypeConfig: Record<string, {
  label: string;
  color: string;
}> = {
  Banner: {
    label: 'Banner',
    color: 'bg-blue-100 text-blue-700 border-blue-200'
  },
  Promo: {
    label: 'Promo',
    color: 'bg-amber-100 text-amber-700 border-amber-200'
  },
  'Pinned astrologer': {
    label: 'Pinned astrologer',
    color: 'bg-purple-100 text-purple-700 border-purple-200'
  },
  'Pinned course': {
    label: 'Pinned course',
    color: 'bg-indigo-100 text-indigo-700 border-indigo-200'
  },
  Email: {
    label: 'Email',
    color: 'bg-emerald-100 text-emerald-700 border-emerald-200'
  },
  'Native article': {
    label: 'Native article',
    color: 'bg-slate-100 text-slate-700 border-slate-200'
  }
};
const statusReasonConfig: Record<string, {
  label: string;
  color: string;
}> = {
  running: {
    label: 'Транслируется',
    color: 'text-emerald-600'
  },
  slot_full: {
    label: 'Слот занят',
    color: 'text-amber-600'
  },
  waiting_start_date: {
    label: 'Ожидает даты',
    color: 'text-blue-600'
  },
  payment_pending: {
    label: 'Ожидает оплаты',
    color: 'text-rose-600'
  },
  impression_limit_reached: {
    label: 'Лимит показов',
    color: 'text-slate-500'
  },
  manual_pause: {
    label: 'Пауза (вручную)',
    color: 'text-slate-500'
  },
  expired: {
    label: 'Истёк срок',
    color: 'text-slate-500'
  },
  completed_naturally: {
    label: 'Завершено',
    color: 'text-slate-500'
  }
};
// Format currency
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0
  }).format(amount);
};
export function AdminAdvertisingFullManager({
  adRequests,
  adPlacements,
  astrologers,
  setActiveTab,
  setDetailPanel,
  success
}: AdminAdvertisingFullManagerProps) {
  const [placements, setPlacements] = useState(mockPlacements);
  const [slotsData, setSlotsData] = useState(mockSlots);
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    type: 'all',
    slot: 'all',
    advertiser: ''
  });
  const [showCreateSlot, setShowCreateSlot] = useState(false);
  const [slotDetailId, setSlotDetailId] = useState<string | null>(null);
  const [editingPlacement, setEditingPlacement] = useState<any | null>(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState<string | null>(null);
  const [showCreatePlacement, setShowCreatePlacement] = useState(false);
  const [showCreatePin, setShowCreatePin] = useState<'astrologer' | 'course' | null>(null);
  const [showCreateCampaign, setShowCreateCampaign] = useState(false);
  const [previewBanner, setPreviewBanner] = useState<any | null>(null);
  const [showRenewModal, setShowRenewModal] = useState<any | null>(null);
  const [showStatsPanel, setShowStatsPanel] = useState<any | null>(null);
  const [activeSubTab, setActiveSubTab] = useState('all');
  // Popover state for interactive elements
  const [activePopover, setActivePopover] = useState<{
    type: string;
    id: string;
    data?: any;
  } | null>(null);
  const popoverRef = useRef<HTMLDivElement>(null);
  // Close popover on outside click or Escape
  useEffect(() => {
    if (!activePopover) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target as Node)) {
        setActivePopover(null);
      }
    };
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActivePopover(null);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [activePopover]);
  // Priority explanation data
  const priorityExplanations: Record<string, {
    label: string;
    description: string;
    color: string;
    bgColor: string;
  }> = {
    critical: {
      label: 'Критический (9-10)',
      description: 'Максимальный приоритет. VIP-клиенты и срочные размещения. Обходят стандартную очередь.',
      color: 'text-rose-700',
      bgColor: 'bg-rose-50 border-rose-200'
    },
    high: {
      label: 'Высокий (7-8)',
      description: 'Повышенный приоритет. Размещения с высоким бюджетом или важные партнёры.',
      color: 'text-amber-700',
      bgColor: 'bg-amber-50 border-amber-200'
    },
    medium: {
      label: 'Средний (4-6)',
      description: 'Стандартный приоритет. Обычные рекламные размещения.',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50 border-blue-200'
    },
    low: {
      label: 'Низкий (1-3)',
      description: 'Минимальный приоритет. Бесплатные или тестовые размещения.',
      color: 'text-slate-600',
      bgColor: 'bg-slate-50 border-slate-200'
    }
  };
  const getPriorityLevel = (priority: number) => {
    if (priority >= 9) return 'critical';
    if (priority >= 7) return 'high';
    if (priority >= 4) return 'medium';
    return 'low';
  };
  // Page grouping config for slots table
  const pageGroupConfig: Record<string, {
    color: string;
    bg: string;
    border: string;
    icon: string;
  }> = {
    Главная: {
      color: 'text-blue-700',
      bg: 'bg-blue-50',
      border: 'border-blue-300',
      icon: '🏠'
    },
    Каталог: {
      color: 'text-purple-700',
      bg: 'bg-purple-50',
      border: 'border-purple-300',
      icon: '📋'
    },
    Блог: {
      color: 'text-emerald-700',
      bg: 'bg-emerald-50',
      border: 'border-emerald-300',
      icon: '📝'
    },
    Email: {
      color: 'text-orange-700',
      bg: 'bg-orange-50',
      border: 'border-orange-300',
      icon: '✉️'
    },
    Гороскоп: {
      color: 'text-amber-700',
      bg: 'bg-amber-50',
      border: 'border-amber-300',
      icon: '⭐'
    },
    'Бесплатная карта': {
      color: 'text-teal-700',
      bg: 'bg-teal-50',
      border: 'border-teal-300',
      icon: '🎴'
    },
    Совместимость: {
      color: 'text-pink-700',
      bg: 'bg-pink-50',
      border: 'border-pink-300',
      icon: '💕'
    },
    'Лунный календарь': {
      color: 'text-indigo-700',
      bg: 'bg-indigo-50',
      border: 'border-indigo-300',
      icon: '🌙'
    },
    'Профиль астролога': {
      color: 'text-violet-700',
      bg: 'bg-violet-50',
      border: 'border-violet-300',
      icon: '👤'
    },
    Услуги: {
      color: 'text-cyan-700',
      bg: 'bg-cyan-50',
      border: 'border-cyan-300',
      icon: '🛍️'
    },
    FAQ: {
      color: 'text-slate-700',
      bg: 'bg-slate-100',
      border: 'border-slate-300',
      icon: '❓'
    },
    Отчёт: {
      color: 'text-rose-700',
      bg: 'bg-rose-50',
      border: 'border-rose-300',
      icon: '📊'
    },
    'Все страницы': {
      color: 'text-sky-700',
      bg: 'bg-sky-50',
      border: 'border-sky-300',
      icon: '🌐'
    }
  };
  const defaultPageGroup = {
    color: 'text-slate-700',
    bg: 'bg-slate-50',
    border: 'border-slate-300',
    icon: '📄'
  };
  const groupedSlotsData = useMemo(() => {
    const pageOrder = ['Главная', 'Каталог', 'Блог', 'Гороскоп', 'Бесплатная карта', 'Совместимость', 'Лунный календарь', 'Профиль астролога', 'Услуги', 'Отчёт', 'FAQ', 'Email', 'Все страницы'];
    const groups: {
      page: string;
      slots: typeof slotsData;
    }[] = [];
    const grouped = new Map<string, typeof slotsData>();
    slotsData.forEach(s => {
      const existing = grouped.get(s.page) || [];
      existing.push(s);
      grouped.set(s.page, existing);
    });
    // Sort by predefined order, then alphabetically for unknown pages
    const sortedPages = [...grouped.keys()].sort((a, b) => {
      const ia = pageOrder.indexOf(a);
      const ib = pageOrder.indexOf(b);
      if (ia !== -1 && ib !== -1) return ia - ib;
      if (ia !== -1) return -1;
      if (ib !== -1) return 1;
      return a.localeCompare(b);
    });
    sortedPages.forEach(page => {
      groups.push({
        page,
        slots: grouped.get(page)!
      });
    });
    return groups;
  }, [slotsData]);
  // Payment detail helper
  const getPaymentDetails = (p: any) => {
    if (p.payment === 'paid' || p.paymentStatus === 'paid') {
      return {
        status: 'Оплачено',
        statusColor: 'text-emerald-700',
        bgColor: 'bg-emerald-50 border-emerald-200',
        icon: '✓',
        details: [{
          label: 'Сумма',
          value: formatCurrency(p.price)
        }, {
          label: 'Метод',
          value: 'Банковский перевод'
        }, {
          label: 'Дата оплаты',
          value: p.periodStart
        }, {
          label: 'Чек №',
          value: `INV-${p.id.replace('PLC-', '')}`
        }]
      };
    }
    return {
      status: 'Ожидает оплаты',
      statusColor: 'text-amber-700',
      bgColor: 'bg-amber-50 border-amber-200',
      icon: '⏳',
      details: [{
        label: 'Сумма к оплате',
        value: formatCurrency(p.price)
      }, {
        label: 'Срок оплаты',
        value: 'До ' + p.periodStart
      }, {
        label: 'Счёт №',
        value: `INV-${p.id.replace('PLC-', '')}`
      }, {
        label: 'Статус',
        value: 'Ожидает подтверждения'
      }]
    };
  };
  // Action Handlers
  const togglePlacementStatus = (id: string, newStatus: string) => {
    setPlacements(placements.map(p => p.id === id ? {
      ...p,
      status: newStatus,
      statusReason: newStatus === 'paused' ? 'manual_pause' : 'running',
      timer: newStatus === 'paused' ? 'На паузе' : `Осталось ${p.daysLeft} дней`
    } : p));
    success(`Статус изменён на ${newStatus === 'active' ? 'Активно' : newStatus === 'paused' ? 'Остановлено' : newStatus}`);
  };
  const toggleSlotStatus = (slotId: string) => {
    setSlotsData(slotsData.map(s => s.id === slotId ? {
      ...s,
      status: s.status === 'active' ? 'paused' : 'active',
      health: s.status === 'active' ? 'paused' : 'healthy'
    } : s));
    const slot = slotsData.find(s => s.id === slotId);
    success(`Слот ${slotId} ${slot?.status === 'active' ? 'остановлен' : 'активирован'}`);
  };
  const deletePlacement = (id: string) => {
    setPlacements(placements.filter(p => p.id !== id));
    setShowDeleteConfirm(null);
    success('Размещение удалено');
  };
  const renewPlacement = (id: string, days: number = 30) => {
    setPlacements(placements.map(p => {
      if (p.id !== id) return p;
      const newDaysLeft = p.daysLeft + days;
      return {
        ...p,
        daysLeft: newDaysLeft,
        timer: `Осталось ${newDaysLeft} дней`,
        autoRenew: true
      };
    }));
    setShowRenewModal(null);
    success(`Размещение ${id} продлено на ${days} дней`);
  };
  const moveQueueItem = (id: string, direction: number) => {
    const item = placements.find(p => p.id === id);
    if (!item || !item.queuePosition) return;
    const currentPos = item.queuePosition;
    const newPos = currentPos + direction;
    if (newPos < 1) return;
    setPlacements(placements.map(p => {
      if (p.id === id) return {
        ...p,
        queuePosition: newPos
      };
      if (p.status === 'queued' && p.queuePosition === newPos) return {
        ...p,
        queuePosition: currentPos
      };
      return p;
    }));
    success(`Приоритет ${direction < 0 ? 'повышен' : 'понижен'}`);
  };
  const activateQueueItem = (id: string) => {
    setPlacements(placements.map(p => p.id === id ? {
      ...p,
      status: 'active',
      queuePosition: null
    } : p));
    success('Активировано вручную');
  };
  const toggleFastTrack = (id: string) => {
    setPlacements(placements.map(p => p.id === id ? {
      ...p,
      fastTrack: !p.fastTrack
    } : p));
    success('Fast Track переключен');
  };
  const renderKpi = (label: string, value: string | number, icon: React.ReactNode, bg: string) => <Card padding="sm" hoverable className="rounded-xl shadow-none border-slate-200 p-4 flex flex-col justify-between h-24 cursor-pointer group" data-id="element-554">
      <div className={`w-8 h-8 rounded-lg ${bg} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-555">
        {icon}
      </div>
      <div data-id="element-556">
        <div className="text-xs text-slate-500 font-medium mb-0.5" data-id="element-557">{label}</div>
        <div className="text-xl font-bold text-slate-900" data-id="element-558">{value}</div>
      </div>
    </Card>;
  const renderAllPlacements = () => {
    const filteredPlacements = placements.filter(p => {
      // Search
      if (searchQuery) {
        const q = searchQuery.toLowerCase();
        if (!p.id.toLowerCase().includes(q) && !p.object.toLowerCase().includes(q) && !p.advertiser.toLowerCase().includes(q) && !p.slotName.toLowerCase().includes(q)) {
          return false;
        }
      }
      // Filters
      if (filters.status !== 'all' && p.status !== filters.status) return false;
      if (filters.type !== 'all' && p.type !== filters.type) return false;
      if (filters.slot !== 'all' && p.slotName !== filters.slot) return false;
      if (filters.advertiser && !p.advertiser.toLowerCase().includes(filters.advertiser.toLowerCase())) return false;
      return true;
    });
    return <div className="space-y-4" data-id="element-559">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3" data-id="element-560">
          {renderKpi('Всего', 8, <Megaphone className="w-4 h-4 text-indigo-600" data-id="element-561" />, 'bg-indigo-50')}
          {renderKpi('Активные', 3, <Play className="w-4 h-4 text-emerald-600" data-id="element-562" />, 'bg-emerald-50')}
          {renderKpi('Доход', '₽185,000', <DollarSign className="w-4 h-4 text-green-600" data-id="element-563" />, 'bg-green-50')}
          {renderKpi('Показы', '98,420', <Eye className="w-4 h-4 text-blue-600" data-id="element-564" />, 'bg-blue-50')}
          {renderKpi('Клики', '4,267', <MousePointer className="w-4 h-4 text-purple-600" data-id="element-565" />, 'bg-purple-50')}
          {renderKpi('Ср. CTR', '4.34%', <TrendingUp className="w-4 h-4 text-amber-600" data-id="element-566" />, 'bg-amber-50')}
          {renderKpi('В очереди', 3, <Layers className="w-4 h-4 text-rose-600" data-id="element-567" />, 'bg-rose-50')}
        </div>

        <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-568">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3" data-id="element-569">
            <div className="relative flex-1 max-w-md" data-id="element-570">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-571" />
              <input type="text" placeholder="Поиск по ID, объекту, рекламодателю..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-572" />
            </div>
            <div className="flex gap-2" data-id="element-573">
              <Button variant={showFilters ? 'primary' : 'outline'} size="sm" icon={<Filter className="w-4 h-4" data-id="element-575" />} onClick={() => setShowFilters(!showFilters)} data-id="element-574">
                Фильтры
              </Button>
              <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-577" />} onClick={() => success('Экспорт размещений завершён')} data-id="element-576">
                Экспорт
              </Button>
            </div>
          </div>

          {showFilters && <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 animate-in slide-in-from-top-2" data-id="element-578">
              <div data-id="element-579">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-580">
                  Статус
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.status} onChange={e => setFilters({
              ...filters,
              status: e.target.value
            })} data-id="element-581">
                  <option value="all" data-id="element-582">Все</option>
                  <option value="active" data-id="element-583">Активно</option>
                  <option value="queued" data-id="element-584">В очереди</option>
                  <option value="scheduled" data-id="element-585">Запланировано</option>
                  <option value="completed" data-id="element-586">Завершено</option>
                  <option value="paused" data-id="element-587">Остановлено</option>
                </select>
              </div>
              <div data-id="element-588">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-589">
                  Тип
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.type} onChange={e => setFilters({
              ...filters,
              type: e.target.value
            })} data-id="element-590">
                  <option value="all" data-id="element-591">Все</option>
                  <option value="Banner" data-id="element-592">Banner</option>
                  <option value="Promo" data-id="element-593">Promo</option>
                  <option value="Pinned astrologer" data-id="element-594">Pinned astrologer</option>
                  <option value="Pinned course" data-id="element-595">Pinned course</option>
                  <option value="Email" data-id="element-596">Email</option>
                  <option value="Native article" data-id="element-597">Native article</option>
                </select>
              </div>
              <div data-id="element-598">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-599">
                  Слот
                </label>
                <select className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.slot} onChange={e => setFilters({
              ...filters,
              slot: e.target.value
            })} data-id="element-600">
                  <option value="all" data-id="element-601">Все</option>
                  <option value="Главная TOP баннер" data-id="element-602">Главная TOP баннер</option>
                  <option value="Сайдбар каталога" data-id="element-603">Сайдбар каталога</option>
                  <option value="Топ каталога" data-id="element-604">Топ каталога</option>
                  <option value="Внутри статьи" data-id="element-605">Внутри статьи</option>
                  <option value="Email дайджест" data-id="element-606">Email дайджест</option>
                </select>
              </div>
              <div data-id="element-607">
                <label className="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-608">
                  Рекламодатель
                </label>
                <input type="text" placeholder="Имя..." className="w-full rounded-lg border border-slate-200 bg-white text-sm py-2 px-3" value={filters.advertiser} onChange={e => setFilters({
              ...filters,
              advertiser: e.target.value
            })} data-id="element-609" />
              </div>
            </div>}
        </Card>

        <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-610">
          <div className="overflow-x-auto" data-id="element-611">
            <table className="w-full text-left whitespace-nowrap" data-id="element-612">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[10px] uppercase tracking-wider" data-id="element-613">
                <tr data-id="element-614">
                  <th className="px-4 py-3 font-medium" data-id="element-615">ID / Объект</th>
                  <th className="px-4 py-3 font-medium" data-id="element-616">Слот / Статус</th>
                  <th className="px-4 py-3 font-medium" data-id="element-617">Тайминг</th>
                  <th className="px-4 py-3 font-medium" data-id="element-618">Коммерция</th>
                  <th className="px-4 py-3 font-medium" data-id="element-619">Показы / Клики</th>
                  <th className="px-4 py-3 text-right font-medium" data-id="element-620">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-621">
                {filteredPlacements.map(p => {
                // Priority styling
                let prioClass = 'bg-slate-100 text-slate-600';
                let prioLabel = 'Низкий';
                if (p.priority >= 9) {
                  prioClass = 'bg-rose-100 text-rose-700';
                  prioLabel = 'Критический';
                } else if (p.priority >= 7) {
                  prioClass = 'bg-amber-100 text-amber-700';
                  prioLabel = 'Высокий';
                } else if (p.priority >= 4) {
                  prioClass = 'bg-blue-100 text-blue-700';
                  prioLabel = 'Средний';
                }
                const fillPercentage = p.impressionsPlan > 0 ? Math.min(100, p.impressionsFact / p.impressionsPlan * 100) : 0;
                return <tr key={p.id} className="hover:bg-slate-50 transition-colors group" data-id="element-622">
                      <td className="px-4 py-3" data-id="element-623">
                        <div className="text-[11px] font-bold text-indigo-600 font-mono mb-1 cursor-pointer hover:text-indigo-800 hover:underline inline-flex items-center gap-1 group/id" onClick={() => setDetailPanel({
                      type: 'ad-placement',
                      title: `Размещение ${p.id}`,
                      data: p
                    })} title="Нажмите для просмотра деталей размещения" data-id="element-624">
                          {p.id}
                          <ExternalLink className="w-2.5 h-2.5 opacity-0 group-hover/id:opacity-100 transition-opacity" data-id="element-625" />
                        </div>
                        <div className="text-sm font-bold text-slate-900 mb-0.5 cursor-pointer hover:text-indigo-600 flex items-center gap-1" onClick={() => setDetailPanel({
                      type: 'ad-placement',
                      title: p.object,
                      data: p
                    })} data-id="element-626">
                          {p.object}{' '}
                          <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-627" />
                        </div>
                        <div className="flex items-center gap-2 mt-1" data-id="element-628">
                          <div className="flex items-center gap-1 text-[10px] text-slate-500" data-id="element-629">
                            <UserCheck className="w-3 h-3" data-id="element-630" /> {p.advertiser}
                          </div>
                          <div className="relative" data-id="element-631">
                            <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[9px] font-bold cursor-pointer hover:ring-2 hover:ring-offset-1 hover:ring-current transition-all ${prioClass}`} onClick={e => {
                          e.stopPropagation();
                          setActivePopover(activePopover?.type === 'priority' && activePopover?.id === p.id ? null : {
                            type: 'priority',
                            id: p.id
                          });
                        }} title="Нажмите для подробностей о приоритете" data-id="element-632">
                              {p.priority} {prioLabel}
                              <ChevronRight className="w-2.5 h-2.5 ml-0.5" data-id="element-633" />
                            </span>
                            {activePopover?.type === 'priority' && activePopover?.id === p.id && <div ref={popoverRef} className={`fixed sm:absolute z-[60] left-4 right-4 sm:left-0 sm:right-auto top-auto sm:top-full sm:mt-1 bottom-4 sm:bottom-auto w-auto sm:w-72 max-w-[calc(100vw-2rem)] p-3 rounded-xl border shadow-xl sm:shadow-lg animate-in fade-in slide-in-from-top-1 duration-150 ${priorityExplanations[getPriorityLevel(p.priority)].bgColor}`} data-id="element-634">
                                  <div className="flex items-center gap-2 mb-2" data-id="element-635">
                                    <Award className="w-4 h-4" data-id="element-636" />
                                    <span className={`text-xs font-bold ${priorityExplanations[getPriorityLevel(p.priority)].color}`} data-id="element-637">
                                      {priorityExplanations[getPriorityLevel(p.priority)].label}
                                    </span>
                                    <button onClick={() => setActivePopover(null)} className="ml-auto p-1 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-white/50" data-id="element-638">
                                      <X className="w-4 h-4 sm:w-3.5 sm:h-3.5" data-id="element-639" />
                                    </button>
                                  </div>
                                  <p className="text-xs sm:text-[11px] text-slate-600 leading-relaxed" data-id="element-640">
                                    {priorityExplanations[getPriorityLevel(p.priority)].description}
                                  </p>
                                  <div className="mt-2 pt-2 border-t border-current/10 flex items-center gap-2" data-id="element-641">
                                    <div className="flex gap-0.5" data-id="element-642">
                                      {[...Array(10)].map((_, i) => <div key={i} className={`w-2.5 h-2.5 sm:w-2 sm:h-2 rounded-sm ${i < p.priority ? p.priority >= 9 ? 'bg-rose-400' : p.priority >= 7 ? 'bg-amber-400' : p.priority >= 4 ? 'bg-blue-400' : 'bg-slate-300' : 'bg-slate-200'}`} data-id="element-643" />)}
                                    </div>
                                    <span className="text-xs sm:text-[10px] font-bold" data-id="element-644">
                                      {p.priority}/10
                                    </span>
                                  </div>
                                </div>}
                          </div>
                        </div>
                      </td>

                      <td className="px-4 py-3" data-id="element-645">
                        <div className="flex items-center gap-1.5 text-xs font-bold text-slate-900 mb-1 cursor-pointer hover:text-indigo-600 transition-colors group/slot" onClick={() => {
                      const sd = slotsData.find(s => s.name === p.slotName);
                      setDetailPanel({
                        type: 'slot-detail',
                        title: `Слот: ${p.slotName}`,
                        data: sd || {
                          name: p.slotName
                        }
                      });
                    }} title="Нажмите для просмотра деталей слота" data-id="element-646">
                          <LayoutList className="w-3 h-3 text-slate-400" data-id="element-647" />{' '}
                          {p.slotName}
                          <ExternalLink className="w-2.5 h-2.5 opacity-0 group-hover/slot:opacity-100 transition-opacity text-indigo-400" data-id="element-648" />
                        </div>
                        <div className="flex items-center gap-2 mb-1" data-id="element-649">
                          <Badge variant={placementStatusConfig[p.status]?.variant || 'neutral'} size="sm" className="text-[9px]" data-id="element-650">
                            {placementStatusConfig[p.status]?.label || p.status}
                          </Badge>
                          <span className={`text-[10px] font-medium ${statusReasonConfig[p.statusReason]?.color || 'text-slate-500'}`} data-id="element-651">
                            {statusReasonConfig[p.statusReason]?.label || p.statusReason}
                          </span>
                        </div>
                        {p.slotCapacity && <div className="relative text-[9px] text-slate-500 flex items-center gap-1" data-id="element-652">
                            <Layers className="w-3 h-3" data-id="element-653" />
                            Занято:{' '}
                            <span className={p.slotCapacity.active === p.slotCapacity.limit ? 'text-emerald-600 font-bold' : ''} data-id="element-654">
                              {p.slotCapacity.active}/{p.slotCapacity.limit}
                            </span>
                            {p.slotCapacity.queued > 0 && <span className="text-amber-600 ml-1 font-bold cursor-pointer hover:underline inline-flex items-center gap-0.5" onClick={e => {
                        e.stopPropagation();
                        setActivePopover(activePopover?.type === 'queue' && activePopover?.id === p.id ? null : {
                          type: 'queue',
                          id: p.id
                        });
                      }} title="Нажмите для просмотра очереди" data-id="element-655">
                                | Очередь: {p.slotCapacity.queued}
                                <ChevronRight className="w-2.5 h-2.5" data-id="element-656" />
                              </span>}
                            {activePopover?.type === 'queue' && activePopover?.id === p.id && <div ref={popoverRef} className="fixed sm:absolute z-[60] left-4 right-4 sm:left-0 sm:right-auto top-auto sm:top-full sm:mt-1 bottom-4 sm:bottom-auto w-auto sm:w-64 max-w-[calc(100vw-2rem)] p-3 rounded-xl border border-amber-200 bg-amber-50 shadow-xl sm:shadow-lg animate-in fade-in slide-in-from-top-1 duration-150" data-id="element-657">
                                  <div className="flex items-center gap-2 mb-2" data-id="element-658">
                                    <Layers className="w-4 h-4 text-amber-600" data-id="element-659" />
                                    <span className="text-xs font-bold text-amber-700" data-id="element-660">
                                      Очередь на слот
                                    </span>
                                    <button onClick={e => {
                            e.stopPropagation();
                            setActivePopover(null);
                          }} className="ml-auto p-1 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-white/50" data-id="element-661">
                                      <X className="w-4 h-4 sm:w-3.5 sm:h-3.5" data-id="element-662" />
                                    </button>
                                  </div>
                                  <div className="space-y-1.5 text-[11px]" data-id="element-663">
                                    <div className="flex justify-between" data-id="element-664">
                                      <span className="text-slate-600" data-id="element-665">
                                        Слот:
                                      </span>
                                      <span className="font-bold text-slate-900" data-id="element-666">
                                        {p.slotName}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-667">
                                      <span className="text-slate-600" data-id="element-668">
                                        Активных:
                                      </span>
                                      <span className="font-bold" data-id="element-669">
                                        {p.slotCapacity.active}/
                                        {p.slotCapacity.limit}
                                      </span>
                                    </div>
                                    <div className="flex justify-between" data-id="element-670">
                                      <span className="text-slate-600" data-id="element-671">
                                        В очереди:
                                      </span>
                                      <span className="font-bold text-amber-700" data-id="element-672">
                                        {p.slotCapacity.queued} размещений
                                      </span>
                                    </div>
                                  </div>
                                  <div className="mt-2 pt-2 border-t border-amber-200" data-id="element-673">
                                    <div className="text-[10px] text-slate-500 mb-1.5" data-id="element-674">
                                      Ожидающие размещения:
                                    </div>
                                    {placements.filter(q => q.status === 'queued' && q.slotName === p.slotName).slice(0, 3).map((q, i) => <div key={q.id} className="flex items-center justify-between py-1 text-[10px]" data-id="element-675">
                                          <span className="font-mono font-bold text-indigo-600 cursor-pointer hover:underline" onClick={e => {
                              e.stopPropagation();
                              setActivePopover(null);
                              setDetailPanel({
                                type: 'ad-placement',
                                title: q.object,
                                data: q
                              });
                            }} data-id="element-676">
                                            {q.id}
                                          </span>
                                          <span className="text-slate-600" data-id="element-677">
                                            {q.object}
                                          </span>
                                          <span className="font-bold" data-id="element-678">
                                            #{q.queuePosition}
                                          </span>
                                        </div>)}
                                  </div>
                                </div>}
                          </div>}
                      </td>

                      <td className="px-4 py-3" data-id="element-679">
                        <div className="flex items-center gap-1.5 text-[10px] text-slate-500 mb-1" data-id="element-680">
                          <Calendar className="w-3 h-3" data-id="element-681" /> {p.periodStart} —{' '}
                          {p.periodEnd}
                        </div>
                        <div className="flex items-center gap-1.5 text-xs font-medium text-slate-800 mb-1" data-id="element-682">
                          {p.status === 'active' ? <Timer className="w-3.5 h-3.5 text-emerald-500" data-id="element-683" /> : <Clock className="w-3.5 h-3.5 text-slate-400" data-id="element-684" />}
                          <span className={p.status === 'active' ? 'text-emerald-600 font-bold' : ''} data-id="element-685">
                            {p.timer}
                          </span>
                          {p.status === 'active' && p.daysLeft <= 3 && <AlertTriangle className="w-3.5 h-3.5 text-amber-500" title="Скоро завершится" data-id="element-686" />}
                        </div>
                        <div className="flex items-center gap-1 text-[10px] text-slate-500" data-id="element-687">
                          <RefreshCw className={`w-3 h-3 ${p.autoRenew ? 'text-emerald-500' : 'text-slate-300'}`} data-id="element-688" />
                          {p.autoRenew ? 'Автопродление вкл.' : 'Без автопродления'}
                        </div>
                      </td>

                      <td className="px-4 py-3" data-id="element-689">
                        <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-690">
                          {formatCurrency(p.price)}
                        </div>
                        <div className="relative" data-id="element-691">
                          <div className="cursor-pointer inline-flex" onClick={e => {
                        e.stopPropagation();
                        setActivePopover(activePopover?.type === 'payment' && activePopover?.id === p.id ? null : {
                          type: 'payment',
                          id: p.id
                        });
                      }} title="Нажмите для деталей оплаты" data-id="element-692">
                            <Badge variant={p.payment === 'paid' ? 'success' : 'warning'} size="sm" className="text-[9px] cursor-pointer hover:ring-2 hover:ring-offset-1 hover:ring-current transition-all" data-id="element-693">
                              {p.payment === 'paid' ? 'Оплачено' : 'Ожидает оплаты'}
                              <ChevronRight className="w-2.5 h-2.5 ml-0.5 inline" data-id="element-694" />
                            </Badge>
                          </div>
                          {activePopover?.type === 'payment' && activePopover?.id === p.id && (() => {
                        const pi = getPaymentDetails(p);
                        return <div ref={popoverRef} className={`fixed sm:absolute z-[60] left-4 right-4 sm:left-0 sm:right-auto top-auto sm:top-full sm:mt-1 bottom-4 sm:bottom-auto w-auto sm:w-64 max-w-[calc(100vw-2rem)] p-3 rounded-xl border shadow-xl sm:shadow-lg animate-in fade-in slide-in-from-top-1 duration-150 ${pi.bgColor}`} data-id="element-695">
                                  <div className="flex items-center gap-2 mb-2" data-id="element-696">
                                    <DollarSign className="w-4 h-4" data-id="element-697" />
                                    <span className={`text-xs font-bold ${pi.statusColor}`} data-id="element-698">
                                      {pi.status}
                                    </span>
                                    <button onClick={e => {
                              e.stopPropagation();
                              setActivePopover(null);
                            }} className="ml-auto text-slate-400 hover:text-slate-600" data-id="element-699">
                                      <X className="w-3.5 h-3.5" data-id="element-700" />
                                    </button>
                                  </div>
                                  <div className="space-y-1.5" data-id="element-701">
                                    {pi.details.map((d, i) => <div key={i} className="flex justify-between text-[11px]" data-id="element-702">
                                        <span className="text-slate-600" data-id="element-703">
                                          {d.label}:
                                        </span>
                                        <span className="font-bold text-slate-900" data-id="element-704">
                                          {d.value}
                                        </span>
                                      </div>)}
                                  </div>
                                  <div className="mt-2 pt-2 border-t border-current/10 flex gap-2" data-id="element-705">
                                    <button className="flex-1 text-[10px] font-bold text-indigo-600 hover:text-indigo-800 flex items-center justify-center gap-1 py-1.5 rounded-lg hover:bg-white/50 transition-colors border border-indigo-200" onClick={e => {
                              e.stopPropagation();
                              setActivePopover(null);
                              setDetailPanel({
                                type: 'payment-detail',
                                title: `Оплата ${p.id}`,
                                data: {
                                  ...p,
                                  ...pi
                                }
                              });
                            }} data-id="element-706">
                                      <Eye className="w-3 h-3" data-id="element-707" /> Подробнее
                                    </button>
                                    {p.payment !== 'paid' && <button className="flex-1 text-[10px] font-bold text-emerald-600 hover:text-emerald-800 flex items-center justify-center gap-1 py-1.5 rounded-lg hover:bg-white/50 transition-colors border border-emerald-200" onClick={e => {
                              e.stopPropagation();
                              setActivePopover(null);
                              success(`Напоминание об оплате отправлено для ${p.id}`);
                            }} data-id="element-708">
                                        <Send className="w-3 h-3" data-id="element-709" /> Напомнить
                                      </button>}
                                  </div>
                                </div>;
                      })()}
                        </div>
                      </td>

                      <td className="px-4 py-3" data-id="element-710">
                        <div className="w-full max-w-[150px]" data-id="element-711">
                          <div className="flex justify-between text-[9px] mb-1" data-id="element-712">
                            <span className="text-slate-500" data-id="element-713">Показы</span>
                            <span className="font-bold text-slate-700" data-id="element-714">
                              {p.impressionsFact.toLocaleString()} /{' '}
                              {p.impressionsPlan.toLocaleString()}
                            </span>
                          </div>
                          <div className="w-full bg-slate-100 rounded-full h-1.5 mb-2" data-id="element-715">
                            <div className={`h-1.5 rounded-full ${fillPercentage >= 100 ? 'bg-emerald-500' : 'bg-indigo-500'}`} style={{
                          width: `${fillPercentage}%`
                        }} data-id="element-716" />
                          </div>
                          <div className="flex justify-between text-[10px]" data-id="element-717">
                            <span className="text-slate-500" data-id="element-718">
                              Клики:{' '}
                              <span className="font-medium text-slate-900" data-id="element-719">
                                {p.clicks.toLocaleString()}
                              </span>
                            </span>
                            <span className="text-slate-500" data-id="element-720">
                              CTR:{' '}
                              <span className="font-bold text-indigo-600" data-id="element-721">
                                {p.ctr}
                              </span>
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="px-4 py-3 text-right" data-id="element-722">
                        <div className="flex items-center justify-end gap-1" data-id="element-723">
                          <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<Eye className="w-3.5 h-3.5" data-id="element-725" />} title="Превью баннера" onClick={() => setPreviewBanner(p)} data-id="element-724" />
                          <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<Edit className="w-3.5 h-3.5" data-id="element-727" />} title="Редактировать" onClick={() => setEditingPlacement(p)} data-id="element-726" />
                          <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<BarChart3 className="w-3.5 h-3.5" data-id="element-729" />} title="Статистика" onClick={() => setShowStatsPanel(p)} data-id="element-728" />
                          {p.status === 'active' && <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-amber-600" icon={<Pause className="w-3.5 h-3.5" data-id="element-731" />} title="Остановить" onClick={() => togglePlacementStatus(p.id, 'paused')} data-id="element-730" />}
                          {p.status === 'paused' && <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-emerald-600" icon={<Play className="w-3.5 h-3.5" data-id="element-733" />} title="Запустить" onClick={() => togglePlacementStatus(p.id, 'active')} data-id="element-732" />}
                          <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<RefreshCw className="w-3.5 h-3.5" data-id="element-735" />} title="Продлить" onClick={() => setShowRenewModal(p)} data-id="element-734" />
                          <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-rose-600" icon={<Trash2 className="w-3.5 h-3.5" data-id="element-737" />} title="Удалить" onClick={() => setShowDeleteConfirm(p.id)} data-id="element-736" />
                        </div>
                      </td>
                    </tr>;
              })}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Edit Placement Modal */}
        {editingPlacement && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-738">
            <Card className="w-full max-w-md shadow-2xl" data-id="element-739">
              <div className="flex justify-between items-center mb-6" data-id="element-740">
                <h3 className="text-lg font-bold text-slate-900" data-id="element-741">
                  Редактирование {editingPlacement.id}
                </h3>
                <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-743" />} onClick={() => setEditingPlacement(null)} data-id="element-742" />
              </div>
              <div className="space-y-4" data-id="element-744">
                <div data-id="element-745">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-746">
                    Объект
                  </label>
                  <input type="text" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" defaultValue={editingPlacement.object} data-id="element-747" />
                </div>
                <div data-id="element-748">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-749">
                    Рекламодатель
                  </label>
                  <input type="text" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" defaultValue={editingPlacement.advertiser} data-id="element-750" />
                </div>
                <div className="grid grid-cols-2 gap-3" data-id="element-751">
                  <div data-id="element-752">
                    <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-753">
                      Цена
                    </label>
                    <input type="number" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" defaultValue={editingPlacement.price} data-id="element-754" />
                  </div>
                  <div data-id="element-755">
                    <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-756">
                      Статус
                    </label>
                    <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" defaultValue={editingPlacement.status} data-id="element-757">
                      <option value="active" data-id="element-758">Активно</option>
                      <option value="paused" data-id="element-759">Остановлено</option>
                      <option value="queued" data-id="element-760">В очереди</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6" data-id="element-761">
                <Button variant="outline" onClick={() => setEditingPlacement(null)} data-id="element-762">
                  Отмена
                </Button>
                <Button variant="primary" onClick={() => {
              success('Изменения сохранены');
              setEditingPlacement(null);
            }} data-id="element-763">
                  Сохранить
                </Button>
              </div>
            </Card>
          </div>}

        {/* Delete Confirmation Modal */}
        {showDeleteConfirm && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-764">
            <Card className="w-full max-w-sm shadow-2xl text-center" data-id="element-765">
              <div className="w-12 h-12 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mx-auto mb-4" data-id="element-766">
                <AlertTriangle className="w-6 h-6" data-id="element-767" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-768">
                Подтвердите удаление
              </h3>
              <p className="text-sm text-slate-500 mb-6" data-id="element-769">
                Вы уверены, что хотите удалить размещение {showDeleteConfirm}?
                Это действие нельзя отменить.
              </p>
              <div className="flex justify-center gap-3" data-id="element-770">
                <Button variant="outline" onClick={() => setShowDeleteConfirm(null)} data-id="element-771">
                  Отмена
                </Button>
                <Button variant="primary" className="bg-rose-600 hover:bg-rose-700" onClick={() => deletePlacement(showDeleteConfirm)} data-id="element-772">
                  Удалить
                </Button>
              </div>
            </Card>
          </div>}
      </div>;
  };
  const renderSlots = () => {
    const activeSlot = slotsData.find(s => s.id === slotDetailId);
    return <div className="space-y-6" data-id="element-773">
        <div className="flex justify-between items-center" data-id="element-774">
          <div data-id="element-775">
            <h2 className="text-xl font-bold text-slate-900" data-id="element-776">Slot Engine</h2>
            <p className="text-sm text-slate-500" data-id="element-777">
              Управление рекламными слотами, ротацией, очередями и динамическим
              ценообразованием
            </p>
          </div>
          <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-779" />} onClick={() => setShowCreateSlot(true)} data-id="element-778">
            Создать слот
          </Button>
        </div>

        {/* KPI Cards */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-780">
          {renderKpi('Всего слотов', slotsData.length, <LayoutList className="w-4 h-4 text-indigo-600" data-id="element-781" />, 'bg-indigo-50')}
          {renderKpi('Здоровые', slotsData.filter(s => s.health === 'healthy').length, <CheckCircle2 className="w-4 h-4 text-emerald-600" data-id="element-782" />, 'bg-emerald-50')}
          {renderKpi('Перегружены', slotsData.filter(s => s.health === 'overloaded').length, <AlertTriangle className="w-4 h-4 text-rose-600" data-id="element-783" />, 'bg-rose-50')}
          {renderKpi('Пустые', slotsData.filter(s => s.health === 'empty').length, <EyeOff className="w-4 h-4 text-slate-600" data-id="element-784" />, 'bg-slate-100')}
          {renderKpi('Ср. ответ CDN', '42ms', <Zap className="w-4 h-4 text-blue-600" data-id="element-785" />, 'bg-blue-50')}
        </div>

        <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-786">
          <div className="overflow-x-auto" data-id="element-787">
            <table className="w-full text-left whitespace-nowrap" data-id="element-788">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[10px] uppercase tracking-wider" data-id="element-789">
                <tr data-id="element-790">
                  <th className="px-4 py-3 font-medium" data-id="element-791">Слот / Статус</th>
                  <th className="px-4 py-3 font-medium" data-id="element-792">Локация / Тип</th>
                  <th className="px-4 py-3 font-medium" data-id="element-793">Движок (Engine)</th>
                  <th className="px-4 py-3 font-medium" data-id="element-794">Коммерция</th>
                  <th className="px-4 py-3 font-medium" data-id="element-795">Метрики</th>
                  <th className="px-4 py-3 text-right font-medium" data-id="element-796">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-797">
                {groupedSlotsData.map(group => {
                const pgConf = pageGroupConfig[group.page] || defaultPageGroup;
                const groupRevenue = group.slots.reduce((sum, s) => sum + s.revenue, 0);
                const groupActive = group.slots.reduce((sum, s) => sum + s.active, 0);
                const groupQueued = group.slots.reduce((sum, s) => sum + s.queued, 0);
                const avgFill = Math.round(group.slots.reduce((sum, s) => sum + s.fillRate, 0) / group.slots.length);
                return <Fragment key={`page-${group.page}`} data-id="element-798">
                      {/* Page Group Header */}
                      <tr className={`${pgConf.bg} border-l-4 ${pgConf.border}`} data-id="element-799">
                        <td colSpan={6} className="px-4 py-2.5" data-id="element-800">
                          <div className="flex items-center justify-between flex-wrap gap-2" data-id="element-801">
                            <div className="flex items-center gap-2.5" data-id="element-802">
                              <span className="text-base" data-id="element-803">{pgConf.icon}</span>
                              <span className={`text-sm font-bold ${pgConf.color}`} data-id="element-804">
                                {group.page}
                              </span>
                              <Badge variant="neutral" size="sm" className="text-[10px] font-mono" data-id="element-805">
                                {group.slots.length}{' '}
                                {group.slots.length === 1 ? 'слот' : group.slots.length < 5 ? 'слота' : 'слотов'}
                              </Badge>
                            </div>
                            <div className="flex items-center gap-4 text-[10px]" data-id="element-806">
                              <span className="text-slate-500" data-id="element-807">
                                Активных:{' '}
                                <strong className="text-emerald-600" data-id="element-808">
                                  {groupActive}
                                </strong>
                              </span>
                              {groupQueued > 0 && <span className="text-slate-500" data-id="element-809">
                                  В очереди:{' '}
                                  <strong className="text-amber-600" data-id="element-810">
                                    {groupQueued}
                                  </strong>
                                </span>}
                              <span className="text-slate-500" data-id="element-811">
                                Fill:{' '}
                                <strong className={avgFill >= 70 ? 'text-emerald-600' : avgFill >= 30 ? 'text-amber-600' : 'text-rose-600'} data-id="element-812">
                                  {avgFill}%
                                </strong>
                              </span>
                              <span className="text-slate-500" data-id="element-813">
                                Доход:{' '}
                                <strong className="text-slate-900" data-id="element-814">
                                  {formatCurrency(groupRevenue)}
                                </strong>
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                      {/* Slots in this page group */}
                      {group.slots.map(s => {
                    const dynamicPrice = s.basePrice * s.demandCoefficient;
                    const healthConfig = {
                      healthy: {
                        color: 'text-emerald-600 bg-emerald-50 border-emerald-200',
                        label: 'Healthy'
                      },
                      empty: {
                        color: 'text-slate-600 bg-slate-50 border-slate-200',
                        label: 'Empty'
                      },
                      overloaded: {
                        color: 'text-rose-600 bg-rose-50 border-rose-200',
                        label: 'Overloaded'
                      },
                      paused: {
                        color: 'text-amber-600 bg-amber-50 border-amber-200',
                        label: 'Paused'
                      }
                    };
                    const h = healthConfig[s.health as keyof typeof healthConfig];
                    return <tr key={s.id} className="hover:bg-slate-50 transition-colors" data-id="element-815">
                            <td className="px-4 py-3" data-id="element-816">
                              <div className="text-sm font-bold text-slate-900 mb-1 cursor-pointer hover:text-indigo-600 transition-colors inline-flex items-center gap-1 group/sname" onClick={() => setSlotDetailId(s.id)} title="Нажмите для настройки слота" data-id="element-817">
                                {s.name}
                                <Settings className="w-3 h-3 opacity-0 group-hover/sname:opacity-100 transition-opacity text-indigo-400" data-id="element-818" />
                              </div>
                              <div className="flex items-center gap-2" data-id="element-819">
                                <span className="text-[10px] font-mono text-indigo-600 font-bold cursor-pointer hover:underline" onClick={() => setSlotDetailId(s.id)} title="Открыть настройки слота" data-id="element-820">
                                  {s.id}
                                </span>
                                <div className="relative" data-id="element-821">
                                  <span className={`text-[9px] px-1.5 py-0.5 rounded border font-bold uppercase tracking-wider cursor-pointer hover:ring-2 hover:ring-offset-1 hover:ring-current transition-all ${h.color}`} onClick={e => {
                              e.stopPropagation();
                              setActivePopover(activePopover?.type === 'health' && activePopover?.id === s.id ? null : {
                                type: 'health',
                                id: s.id
                              });
                            }} title="Нажмите для подробностей о статусе" data-id="element-822">
                                    {h.label}
                                    <ChevronRight className="w-2.5 h-2.5 ml-0.5 inline" data-id="element-823" />
                                  </span>
                                  {activePopover?.type === 'health' && activePopover?.id === s.id && <div ref={popoverRef} className={`fixed sm:absolute z-[60] left-4 right-4 sm:left-0 sm:right-auto top-auto sm:top-full sm:mt-1 bottom-4 sm:bottom-auto w-auto sm:w-64 max-w-[calc(100vw-2rem)] p-3 rounded-xl border shadow-xl sm:shadow-lg animate-in fade-in slide-in-from-top-1 duration-150 ${s.health === 'healthy' ? 'bg-emerald-50 border-emerald-200' : s.health === 'overloaded' ? 'bg-rose-50 border-rose-200' : s.health === 'empty' ? 'bg-slate-50 border-slate-200' : 'bg-amber-50 border-amber-200'}`} data-id="element-824">
                                        <div className="flex items-center gap-2 mb-2" data-id="element-825">
                                          <Activity className="w-4 h-4" data-id="element-826" />
                                          <span className="text-xs font-bold" data-id="element-827">
                                            {h.label}
                                          </span>
                                          <button onClick={() => setActivePopover(null)} className="ml-auto text-slate-400 hover:text-slate-600" data-id="element-828">
                                            <X className="w-3.5 h-3.5" data-id="element-829" />
                                          </button>
                                        </div>
                                        <p className="text-[11px] text-slate-600 leading-relaxed mb-2" data-id="element-830">
                                          {s.health === 'healthy' && 'Слот работает нормально. Все размещения активны, метрики в пределах нормы.'}
                                          {s.health === 'overloaded' && 'Слот перегружен! Очередь превышает 10 позиций. Рекомендуется увеличить лимит или создать дополнительный слот.'}
                                          {s.health === 'empty' && 'Слот пуст — нет активных размещений. Используется fallback-контент или скрыт.'}
                                          {s.health === 'paused' && 'Слот приостановлен администратором. Размещения не транслируются.'}
                                        </p>
                                        <div className="space-y-1 text-[10px]" data-id="element-831">
                                          <div className="flex justify-between" data-id="element-832">
                                            <span className="text-slate-500" data-id="element-833">
                                              Активных:
                                            </span>
                                            <span className="font-bold" data-id="element-834">
                                              {s.active}/{s.limit}
                                            </span>
                                          </div>
                                          <div className="flex justify-between" data-id="element-835">
                                            <span className="text-slate-500" data-id="element-836">
                                              В очереди:
                                            </span>
                                            <span className="font-bold" data-id="element-837">
                                              {s.queued}
                                            </span>
                                          </div>
                                          <div className="flex justify-between" data-id="element-838">
                                            <span className="text-slate-500" data-id="element-839">
                                              Fill Rate:
                                            </span>
                                            <span className="font-bold" data-id="element-840">
                                              {s.fillRate}%
                                            </span>
                                          </div>
                                          <div className="flex justify-between" data-id="element-841">
                                            <span className="text-slate-500" data-id="element-842">
                                              Время ответа:
                                            </span>
                                            <span className="font-bold" data-id="element-843">
                                              {s.responseTime}ms
                                            </span>
                                          </div>
                                        </div>
                                      </div>}
                                </div>
                              </div>
                              <div className="mt-1.5 text-[10px] text-slate-500 flex items-center gap-1" data-id="element-844">
                                <Layers className="w-3 h-3" data-id="element-845" />
                                Занято:{' '}
                                <span className="font-bold text-slate-700" data-id="element-846">
                                  {s.active}/{s.limit}
                                </span>
                                {s.queued > 0 && <span className="text-amber-600 ml-1 font-bold cursor-pointer hover:underline inline-flex items-center gap-0.5" onClick={e => {
                            e.stopPropagation();
                            setActivePopover(activePopover?.type === 'slotqueue' && activePopover?.id === s.id ? null : {
                              type: 'slotqueue',
                              id: s.id
                            });
                          }} title="Нажмите для просмотра очереди" data-id="element-847">
                                    Очередь: {s.queued}
                                    <ChevronRight className="w-2.5 h-2.5" data-id="element-848" />
                                  </span>}
                                {activePopover?.type === 'slotqueue' && activePopover?.id === s.id && <div ref={popoverRef} className="fixed sm:absolute z-[60] left-4 right-4 sm:left-0 sm:right-auto top-auto sm:top-full sm:mt-1 bottom-4 sm:bottom-auto w-auto sm:w-64 max-w-[calc(100vw-2rem)] p-3 rounded-xl border border-amber-200 bg-amber-50 shadow-xl sm:shadow-lg animate-in fade-in slide-in-from-top-1 duration-150" data-id="element-849">
                                      <div className="flex items-center gap-2 mb-2" data-id="element-850">
                                        <Layers className="w-4 h-4 text-amber-600" data-id="element-851" />
                                        <span className="text-xs font-bold text-amber-700" data-id="element-852">
                                          Очередь: {s.name}
                                        </span>
                                        <button onClick={e => {
                                e.stopPropagation();
                                setActivePopover(null);
                              }} className="ml-auto text-slate-400 hover:text-slate-600" data-id="element-853">
                                          <X className="w-3.5 h-3.5" data-id="element-854" />
                                        </button>
                                      </div>
                                      <div className="space-y-1 text-[11px] mb-2" data-id="element-855">
                                        <div className="flex justify-between" data-id="element-856">
                                          <span className="text-slate-600" data-id="element-857">
                                            Ожидают:
                                          </span>
                                          <span className="font-bold text-amber-700" data-id="element-858">
                                            {s.queued} размещений
                                          </span>
                                        </div>
                                        {s.slotReleaseTimer && <div className="flex justify-between" data-id="element-859">
                                            <span className="text-slate-600" data-id="element-860">
                                              Освободится через:
                                            </span>
                                            <span className="font-bold text-slate-900" data-id="element-861">
                                              {s.slotReleaseTimer}
                                            </span>
                                          </div>}
                                      </div>
                                      {placements.filter(q => q.status === 'queued' && q.slotName === s.name).slice(0, 3).map(q => <div key={q.id} className="flex items-center justify-between py-1 text-[10px] border-t border-amber-100" data-id="element-862">
                                            <span className="font-mono font-bold text-indigo-600 cursor-pointer hover:underline" onClick={e => {
                                e.stopPropagation();
                                setActivePopover(null);
                                setDetailPanel({
                                  type: 'ad-placement',
                                  title: q.object,
                                  data: q
                                });
                              }} data-id="element-863">
                                              {q.id}
                                            </span>
                                            <span className="text-slate-600 truncate mx-2" data-id="element-864">
                                              {q.object}
                                            </span>
                                            <span className="font-bold" data-id="element-865">
                                              #{q.queuePosition}
                                            </span>
                                          </div>)}
                                    </div>}
                              </div>
                            </td>

                            <td className="px-4 py-3" data-id="element-866">
                              <div className="text-xs font-bold text-slate-700 mb-1" data-id="element-867">
                                {s.page}
                              </div>
                              <div className="flex items-center gap-1.5 mb-1" data-id="element-868">
                                <Badge variant="neutral" size="sm" className="text-[9px]" data-id="element-869">
                                  {s.type}
                                </Badge>
                                <span className="text-[10px] text-slate-500" data-id="element-870">
                                  {s.size}
                                </span>
                              </div>
                              <div className="text-[9px] text-slate-400 flex items-center gap-1" data-id="element-871">
                                <Globe className="w-3 h-3" data-id="element-872" /> {s.geo.join(', ')}
                              </div>
                            </td>

                            <td className="px-4 py-3" data-id="element-873">
                              <div className="flex flex-col gap-1" data-id="element-874">
                                <div className="flex items-center gap-1.5 text-[10px]" data-id="element-875">
                                  <span className="text-slate-500 w-12" data-id="element-876">
                                    Ротация:
                                  </span>
                                  <span className="font-bold text-indigo-600 uppercase" data-id="element-877">
                                    {s.rotation}
                                  </span>
                                </div>
                                <div className="flex items-center gap-1.5 text-[10px]" data-id="element-878">
                                  <span className="text-slate-500 w-12" data-id="element-879">
                                    Refresh:
                                  </span>
                                  <span className="font-medium text-slate-700" data-id="element-880">
                                    {s.refreshLogic}{' '}
                                    {s.refreshInterval ? `(${s.refreshInterval}s)` : ''}
                                  </span>
                                </div>
                                <div className="flex items-center gap-1.5 text-[10px]" data-id="element-881">
                                  <span className="text-slate-500 w-12" data-id="element-882">
                                    Fallback:
                                  </span>
                                  <span className="font-medium text-slate-700" data-id="element-883">
                                    {s.fallback}
                                  </span>
                                </div>
                                <div className="flex items-center gap-1 mt-0.5" data-id="element-884">
                                  {s.cacheEnabled && <span className="text-[8px] bg-emerald-100 text-emerald-700 px-1 rounded" data-id="element-885">
                                      Redis Cache
                                    </span>}
                                  {s.cdnEnabled && <span className="text-[8px] bg-blue-100 text-blue-700 px-1 rounded" data-id="element-886">
                                      CDN
                                    </span>}
                                  <span className="text-[8px] text-slate-400 ml-1" data-id="element-887">
                                    {s.responseTime}ms
                                  </span>
                                </div>
                              </div>
                            </td>

                            <td className="px-4 py-3" data-id="element-888">
                              <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-889">
                                {formatCurrency(dynamicPrice)}
                                {s.demandCoefficient !== 1 && <span className={`ml-1.5 text-[10px] ${s.demandCoefficient > 1 ? 'text-emerald-600' : 'text-rose-600'}`} data-id="element-890">
                                    (x{s.demandCoefficient})
                                  </span>}
                              </div>
                              <div className="flex items-center gap-1.5 text-[10px] mb-1.5" data-id="element-891">
                                <span className="text-slate-500" data-id="element-892">Базовая:</span>
                                <span className="font-medium text-slate-700" data-id="element-893">
                                  {formatCurrency(s.basePrice)}
                                </span>
                                <span className="text-slate-300" data-id="element-894">|</span>
                                <span className="font-bold text-slate-700 uppercase" data-id="element-895">
                                  {s.paymentType}
                                </span>
                              </div>
                              <div className="w-full bg-slate-100 rounded-full h-1.5 max-w-[120px]" data-id="element-896">
                                <div className={`h-1.5 rounded-full ${s.fillRate >= 80 ? 'bg-emerald-500' : s.fillRate >= 30 ? 'bg-amber-500' : 'bg-rose-500'}`} style={{
                            width: `${s.fillRate}%`
                          }} data-id="element-897" />
                              </div>
                              <div className="text-[9px] text-slate-500 mt-0.5" data-id="element-898">
                                Fill rate: {s.fillRate}%
                              </div>
                            </td>

                            <td className="px-4 py-3" data-id="element-899">
                              <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-[10px]" data-id="element-900">
                                <div className="text-slate-500" data-id="element-901">Показы:</div>
                                <div className="font-bold text-slate-900 text-right" data-id="element-902">
                                  {s.impressions.toLocaleString()}
                                </div>
                                <div className="text-slate-500" data-id="element-903">Клики:</div>
                                <div className="font-bold text-slate-900 text-right" data-id="element-904">
                                  {s.clicks.toLocaleString()}
                                </div>
                                <div className="text-slate-500" data-id="element-905">CTR:</div>
                                <div className="font-bold text-indigo-600 text-right" data-id="element-906">
                                  {s.ctr}
                                </div>
                                <div className="text-slate-500" data-id="element-907">Доход:</div>
                                <div className="font-bold text-emerald-600 text-right" data-id="element-908">
                                  {formatCurrency(s.revenue)}
                                </div>
                              </div>
                            </td>

                            <td className="px-4 py-3 text-right" data-id="element-909">
                              <div className="flex items-center justify-end gap-1" data-id="element-910">
                                <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-emerald-600" icon={<Eye className="w-3.5 h-3.5" data-id="element-912" />} title="Превью баннера" onClick={() => setPreviewBanner({
                            type: 'preview',
                            slot: s
                          })} data-id="element-911" />
                                <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<Activity className="w-3.5 h-3.5" data-id="element-914" />} title="События и логи" onClick={() => setPreviewBanner({
                            type: 'events',
                            slot: s
                          })} data-id="element-913" />
                                <Button variant="ghost" size="sm" className={`w-7 h-7 p-0 ${s.status === 'active' ? 'text-slate-400 hover:text-amber-600' : 'text-amber-500 hover:text-emerald-600'}`} icon={s.status === 'active' ? <Pause className="w-3.5 h-3.5" data-id="element-916" /> : <Play className="w-3.5 h-3.5" data-id="element-917" />} title={s.status === 'active' ? 'Остановить слот' : 'Активировать слот'} onClick={() => toggleSlotStatus(s.id)} data-id="element-915" />
                                <Button variant="ghost" size="sm" className="w-7 h-7 p-0 text-slate-400 hover:text-indigo-600" icon={<Settings className="w-3.5 h-3.5" data-id="element-919" />} title="Настройки движка" onClick={() => setSlotDetailId(s.id)} data-id="element-918" />
                              </div>
                            </td>
                          </tr>;
                  })}
                    </Fragment>;
              })}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Slot Engine Settings Modal */}
        {slotDetailId && activeSlot && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-920">
            <Card className="w-full max-w-4xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden" padding="none" data-id="element-921">
              <div className="p-4 border-b border-slate-200 flex justify-between items-center bg-white shrink-0" data-id="element-922">
                <div data-id="element-923">
                  <div className="flex items-center gap-2" data-id="element-924">
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-925">
                      Настройка Slot Engine
                    </h3>
                    <Badge variant="pro" size="sm" className="font-mono text-[10px]" data-id="element-926">
                      {activeSlot.id}
                    </Badge>
                  </div>
                  <p className="text-sm text-slate-500" data-id="element-927">
                    {activeSlot.name} • {activeSlot.page}
                  </p>
                </div>
                <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-929" />} onClick={() => setSlotDetailId(null)} data-id="element-928" />
              </div>

              <div className="flex-1 overflow-y-auto p-6 bg-slate-50" data-id="element-930">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-931">
                  {/* Left Column - Core & Logic */}
                  <div className="lg:col-span-2 space-y-6" data-id="element-932">
                    <Card padding="sm" className="border-slate-200 shadow-sm" data-id="element-933">
                      <h4 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-934">
                        <RefreshCw className="w-4 h-4 text-indigo-500" data-id="element-935" /> Логика
                        ротации (Rotation Engine)
                      </h4>
                      <div className="grid grid-cols-2 gap-4" data-id="element-936">
                        <div data-id="element-937">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-938">
                            Алгоритм ротации
                          </label>
                          <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.rotation} data-id="element-939">
                            <option value="queue" data-id="element-940">Queue (Очередь, FIFO)</option>
                            <option value="random" data-id="element-941">
                              Random (Случайный выбор)
                            </option>
                            <option value="weighted" data-id="element-942">
                              Weighted (По приоритету * CTR)
                            </option>
                            <option value="static" data-id="element-943">
                              Static (Фиксированный)
                            </option>
                          </select>
                        </div>
                        <div data-id="element-944">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-945">
                            Триггер обновления
                          </label>
                          <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.refreshLogic} data-id="element-946">
                            <option value="every_request" data-id="element-947">
                              При каждом запросе
                            </option>
                            <option value="every_session" data-id="element-948">
                              На сессию пользователя
                            </option>
                            <option value="interval" data-id="element-949">
                              По таймеру (Interval)
                            </option>
                          </select>
                        </div>
                        <div data-id="element-950">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-951">
                            Лимит слота (вместимость)
                          </label>
                          <input type="number" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.limit} data-id="element-952" />
                        </div>
                        <div data-id="element-953">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-954">
                            Интервал обновления (сек)
                          </label>
                          <input type="number" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.refreshInterval || ''} placeholder="Только для Interval" disabled={activeSlot.refreshLogic !== 'interval'} data-id="element-955" />
                        </div>
                      </div>
                    </Card>

                    <Card padding="sm" className="border-slate-200 shadow-sm" data-id="element-956">
                      <h4 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-957">
                        <DollarSign className="w-4 h-4 text-emerald-500" data-id="element-958" />{' '}
                        Динамическая монетизация
                      </h4>
                      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-959">
                        <div data-id="element-960">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-961">
                            Базовая цена (₽)
                          </label>
                          <input type="number" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.basePrice} data-id="element-962" />
                        </div>
                        <div data-id="element-963">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-964">
                            Тип оплаты
                          </label>
                          <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.paymentType} data-id="element-965">
                            <option value="fixed" data-id="element-966">Fixed (Фиксированная)</option>
                            <option value="CPM" data-id="element-967">CPM (За 1000 показов)</option>
                            <option value="CPC" data-id="element-968">CPC (За клик)</option>
                          </select>
                        </div>
                      </div>
                      <div className="bg-slate-50 p-3 rounded-lg border border-slate-200" data-id="element-969">
                        <div className="text-xs font-bold text-slate-700 mb-2" data-id="element-970">
                          Правила Dynamic Pricing:
                        </div>
                        <div className="space-y-2 text-xs text-slate-600" data-id="element-971">
                          <div className="flex justify-between items-center" data-id="element-972">
                            <span data-id="element-973">Если Fill Rate &gt; 80%</span>
                            <span className="font-mono bg-white px-2 py-0.5 rounded border" data-id="element-974">
                              price * 1.5
                            </span>
                          </div>
                          <div className="flex justify-between items-center" data-id="element-975">
                            <span data-id="element-976">Если Fill Rate &lt; 30%</span>
                            <span className="font-mono bg-white px-2 py-0.5 rounded border" data-id="element-977">
                              price * 0.7
                            </span>
                          </div>
                          <div className="flex justify-between items-center pt-2 border-t border-slate-200 mt-2" data-id="element-978">
                            <span className="font-bold" data-id="element-979">
                              Текущий множитель спроса:
                            </span>
                            <span className={`font-bold ${activeSlot.demandCoefficient > 1 ? 'text-emerald-600' : 'text-rose-600'}`} data-id="element-980">
                              x{activeSlot.demandCoefficient}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Card>

                    <Card padding="sm" className="border-slate-200 shadow-sm" data-id="element-981">
                      <h4 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-982">
                        <AlertTriangle className="w-4 h-4 text-amber-500" data-id="element-983" />{' '}
                        Fallback & High Load
                      </h4>
                      <div className="grid grid-cols-2 gap-4" data-id="element-984">
                        <div data-id="element-985">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-986">
                            Fallback (Если слот пуст)
                          </label>
                          <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.fallback} data-id="element-987">
                            <option value="hide" data-id="element-988">Скрыть блок (Hide)</option>
                            <option value="internal_banner" data-id="element-989">
                              Внутренняя реклама Astriqo
                            </option>
                            <option value="placeholder" data-id="element-990">
                              Заглушка "Купить рекламу"
                            </option>
                          </select>
                        </div>
                        <div className="space-y-3 pt-6" data-id="element-991">
                          <label className="flex items-center gap-2" data-id="element-992">
                            <input type="checkbox" className="rounded border-slate-300 text-indigo-600 focus:ring-indigo-500" defaultChecked={activeSlot.cacheEnabled} data-id="element-993" />
                            <span className="text-sm font-medium text-slate-700" data-id="element-994">
                              Кеширование слота (Redis)
                            </span>
                          </label>
                          <label className="flex items-center gap-2" data-id="element-995">
                            <input type="checkbox" className="rounded border-slate-300 text-indigo-600 focus:ring-indigo-500" defaultChecked={activeSlot.cdnEnabled} data-id="element-996" />
                            <span className="text-sm font-medium text-slate-700" data-id="element-997">
                              CDN для баннеров
                            </span>
                          </label>
                        </div>
                      </div>
                    </Card>
                  </div>

                  {/* Right Column - Status & Notifications */}
                  <div className="space-y-6" data-id="element-998">
                    <Card padding="sm" className="border-slate-200 shadow-sm bg-white" data-id="element-999">
                      <h4 className="text-sm font-bold text-slate-900 mb-4" data-id="element-1000">
                        Статус слота
                      </h4>
                      <div className="space-y-4" data-id="element-1001">
                        <div data-id="element-1002">
                          <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-1003">
                            Состояние
                          </label>
                          <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500" defaultValue={activeSlot.status} data-id="element-1004">
                            <option value="active" data-id="element-1005">
                              Active (Принимает рекламу)
                            </option>
                            <option value="paused" data-id="element-1006">Paused (Остановлен)</option>
                            <option value="disabled" data-id="element-1007">
                              Disabled (Отключен)
                            </option>
                          </select>
                        </div>
                        <div className="pt-4 border-t border-slate-100" data-id="element-1008">
                          <div className="text-xs text-slate-500 mb-1" data-id="element-1009">
                            Ближайшее освобождение:
                          </div>
                          <div className="font-medium text-slate-900" data-id="element-1010">
                            {activeSlot.slotReleaseAt ? new Date(activeSlot.slotReleaseAt).toLocaleString('ru-RU') : 'Нет активных'}
                          </div>
                          {activeSlot.slotReleaseTimer && <div className="text-xs font-bold text-indigo-600 mt-0.5" data-id="element-1011">
                              Через {activeSlot.slotReleaseTimer}
                            </div>}
                        </div>
                      </div>
                    </Card>

                    <Card padding="sm" className="border-slate-200 shadow-sm" data-id="element-1012">
                      <h4 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-1013">
                        <Mail className="w-4 h-4 text-blue-500" data-id="element-1014" /> SMS &
                        Уведомления
                      </h4>
                      <div className="space-y-3" data-id="element-1015">
                        <label className="flex items-start gap-2" data-id="element-1016">
                          <input type="checkbox" className="rounded border-slate-300 text-indigo-600 mt-1" defaultChecked data-id="element-1017" />
                          <span className="text-sm text-slate-700" data-id="element-1018">
                            Старт рекламы (Рекламодателю)
                          </span>
                        </label>
                        <label className="flex items-start gap-2" data-id="element-1019">
                          <input type="checkbox" className="rounded border-slate-300 text-indigo-600 mt-1" defaultChecked data-id="element-1020" />
                          <span className="text-sm text-slate-700" data-id="element-1021">
                            Окончание рекламы (За 24ч)
                          </span>
                        </label>
                        <label className="flex items-start gap-2" data-id="element-1022">
                          <input type="checkbox" className="rounded border-slate-300 text-indigo-600 mt-1" defaultChecked data-id="element-1023" />
                          <span className="text-sm text-slate-700" data-id="element-1024">
                            Слот освободился (Первому в очереди)
                          </span>
                        </label>
                        <label className="flex items-start gap-2" data-id="element-1025">
                          <input type="checkbox" className="rounded border-slate-300 text-indigo-600 mt-1" defaultChecked data-id="element-1026" />
                          <span className="text-sm text-slate-700" data-id="element-1027">
                            Ошибка оплаты / Остановка
                          </span>
                        </label>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>

              <div className="p-4 border-t border-slate-200 bg-white flex justify-end gap-3 shrink-0" data-id="element-1028">
                <Button variant="outline" onClick={() => setSlotDetailId(null)} data-id="element-1029">
                  Отмена
                </Button>
                <Button variant="primary" onClick={() => {
              success('Настройки Slot Engine сохранены');
              setSlotDetailId(null);
            }} data-id="element-1030">
                  Сохранить конфигурацию
                </Button>
              </div>
            </Card>
          </div>}

        {/* Events Modal */}
        {previewBanner?.type === 'events' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1031">
            <Card className="w-full max-w-2xl shadow-2xl" data-id="element-1032">
              <div className="flex justify-between items-center mb-6" data-id="element-1033">
                <div data-id="element-1034">
                  <h3 className="text-lg font-bold text-slate-900" data-id="element-1035">
                    Event Log: {previewBanner.slot.name}
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-1036">
                    События движка и системные логи
                  </p>
                </div>
                <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1038" />} onClick={() => setPreviewBanner(null)} data-id="element-1037" />
              </div>

              <div className="bg-slate-900 rounded-xl p-4 overflow-hidden" data-id="element-1039">
                <div className="space-y-3 font-mono text-xs" data-id="element-1040">
                  {previewBanner.slot.events.map((ev: any, i: number) => <div key={i} className="flex items-start gap-3 border-b border-slate-800 pb-2 last:border-0 last:pb-0" data-id="element-1041">
                      <span className="text-slate-500 shrink-0 w-24" data-id="element-1042">
                        {ev.time}
                      </span>
                      <span className={`shrink-0 w-48 font-bold ${ev.type.includes('Error') || ev.type.includes('Alert') ? 'text-rose-400' : ev.type.includes('Success') || ev.type.includes('Freed') ? 'text-emerald-400' : 'text-blue-400'}`} data-id="element-1043">
                        [{ev.type}]
                      </span>
                      <span className="text-slate-300" data-id="element-1044">{ev.description}</span>
                    </div>)}
                  {previewBanner.slot.events.length === 0 && <div className="text-slate-500 text-center py-4" data-id="element-1045">
                      Нет недавних событий
                    </div>}
                </div>
              </div>

              <div className="flex justify-end mt-6" data-id="element-1046">
                <Button variant="outline" onClick={() => setPreviewBanner(null)} data-id="element-1047">
                  Закрыть
                </Button>
              </div>
            </Card>
          </div>}

        {/* Banner Preview Modal */}
        {previewBanner?.type === 'preview' && (() => {
        const s = previewBanner.slot;
        const isSidebar = s.size === '300×600' || s.size === '300×250';
        const isSticky = s.size === '320×50';
        const isCard = s.size === 'Карточка';
        const isEmail = s.type === 'Email';
        const sizeDescriptions: Record<string, string> = {
          '1140×250': 'Широкий горизонтальный баннер на всю ширину контента',
          '728×90': 'Горизонтальный баннер между контентом',
          '300×600': 'Вертикальный баннер в боковой панели',
          '300×250': 'Компактный баннер в боковой панели',
          Карточка: 'Нативная карточка, встроенная в контент',
          '320×50': 'Мобильный sticky-баннер внизу экрана',
          Блок: 'Рекламный блок в email-рассылке'
        };
        const pageLocations: Record<string, string> = {
          'SLOT-01': 'Главная → верх страницы, под хедером',
          'SLOT-02': 'Каталог астрологов → левый сайдбар',
          'SLOT-03': 'Статья блога → правый сайдбар',
          'SLOT-04': 'Каталог астрологов → закреплённые карточки сверху',
          'SLOT-05': 'Email-дайджест → рекламный блок',
          'SLOT-06': 'Гороскоп → после основного контента',
          'SLOT-07': 'Гороскоп → перед кросс-ссылками',
          'SLOT-08': 'Бесплатная карта → после расчёта (шаг 4)',
          'SLOT-09': 'Блог → после пагинации статей',
          'SLOT-10': 'Совместимость → после блока тарифов',
          'SLOT-11': 'Лунный календарь → перед финальным CTA',
          'SLOT-12': 'Профиль астролога → перед «Похожие астрологи»',
          'SLOT-13': 'Страница услуги → перед FAQ',
          'SLOT-14': 'FAQ → перед блоком поддержки',
          'SLOT-15': 'Главная → после отзывов',
          'SLOT-16': 'Маркетплейс услуг → между карточками (каждые 4)',
          'SLOT-17': 'Полный натальный отчёт → перед кнопками консультации',
          'SLOT-18': 'Все страницы → sticky внизу (только мобильные)',
          'SLOT-19': 'Маркетплейс услуг → левый сайдбар',
          'SLOT-20': 'Каталог астрологов → между карточками (каждые 6)',
          'SLOT-21': 'Статья блога → inline после 2-й секции'
        };
        const mockHandler = () => success('Клик по баннеру (превью)');
        return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1048">
                <Card className="w-full max-w-4xl shadow-2xl max-h-[90vh] flex flex-col" padding="none" data-id="element-1049">
                  {/* Header */}
                  <div className="p-5 border-b border-slate-200 flex justify-between items-start shrink-0" data-id="element-1050">
                    <div data-id="element-1051">
                      <div className="flex items-center gap-3 mb-1" data-id="element-1052">
                        <h3 className="text-lg font-bold text-slate-900" data-id="element-1053">
                          {s.name}
                        </h3>
                        <Badge variant="pro" size="sm" className="font-mono text-[10px]" data-id="element-1054">
                          {s.id}
                        </Badge>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-1055">
                        <span className="px-2 py-0.5 bg-slate-100 rounded text-xs font-medium" data-id="element-1056">
                          {s.type}
                        </span>
                        <span className="px-2 py-0.5 bg-slate-100 rounded text-xs font-medium" data-id="element-1057">
                          {s.size}
                        </span>
                        <span data-id="element-1058">•</span>
                        <span data-id="element-1059">{s.page}</span>
                      </div>
                    </div>
                    <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1061" />} onClick={() => setPreviewBanner(null)} data-id="element-1060" />
                  </div>

                  {/* Content */}
                  <div className="flex-1 overflow-y-auto p-5 space-y-5 bg-slate-50" data-id="element-1062">
                    {/* Location info */}
                    <div className="flex items-start gap-3 p-3 bg-indigo-50 rounded-xl border border-indigo-100" data-id="element-1063">
                      <Globe className="w-4 h-4 text-indigo-500 mt-0.5 shrink-0" data-id="element-1064" />
                      <div data-id="element-1065">
                        <div className="text-xs font-bold text-indigo-700 mb-0.5" data-id="element-1066">
                          Расположение на сайте
                        </div>
                        <div className="text-sm text-indigo-600" data-id="element-1067">
                          {pageLocations[s.id] || `${s.page} — ${s.name}`}
                        </div>
                      </div>
                    </div>

                    {/* Size description */}
                    <div className="flex items-start gap-3 p-3 bg-slate-100 rounded-xl" data-id="element-1068">
                      <Layers className="w-4 h-4 text-slate-500 mt-0.5 shrink-0" data-id="element-1069" />
                      <div data-id="element-1070">
                        <div className="text-xs font-bold text-slate-700 mb-0.5" data-id="element-1071">
                          Формат: {s.size}
                        </div>
                        <div className="text-sm text-slate-500" data-id="element-1072">
                          {sizeDescriptions[s.size] || s.size}
                        </div>
                      </div>
                    </div>

                    {/* Live Preview */}
                    <div className="rounded-xl border-2 border-dashed border-slate-300 bg-white p-6" data-id="element-1073">
                      <div className="text-[10px] font-bold text-emerald-600 uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-1074">
                        <Eye className="w-3.5 h-3.5" data-id="element-1075" />
                        Живое превью баннера
                      </div>

                      {isEmail ? <div className="flex items-center justify-center py-12 text-slate-400" data-id="element-1076">
                          <div className="text-center" data-id="element-1077">
                            <Mail className="w-10 h-10 mx-auto mb-3 opacity-50" data-id="element-1078" />
                            <div className="text-sm font-medium" data-id="element-1079">
                              Email-баннер
                            </div>
                            <div className="text-xs mt-1" data-id="element-1080">
                              Отображается в email-рассылке, не на сайте
                            </div>
                          </div>
                        </div> : isSticky ? <div className="relative bg-slate-100 rounded-xl overflow-hidden" style={{
                  height: 200
                }} data-id="element-1081">
                          <div className="absolute inset-x-0 top-0 h-[150px] flex items-center justify-center text-slate-300 text-xs" data-id="element-1082">
                            Контент страницы
                          </div>
                          <div className="absolute inset-x-0 bottom-0" data-id="element-1083">
                            <AdSlot slotId={s.id} onNavigate={mockHandler} showDebug data-id="element-1084" />
                          </div>
                        </div> : isSidebar ? <div className="flex gap-6" data-id="element-1085">
                          <div className="flex-1 bg-slate-50 rounded-xl p-4 flex items-center justify-center min-h-[200px]" data-id="element-1086">
                            <div className="text-center text-slate-300 text-xs" data-id="element-1087">
                              <div className="w-full h-3 bg-slate-200 rounded mb-2" data-id="element-1088" />
                              <div className="w-3/4 h-3 bg-slate-200 rounded mb-2 mx-auto" data-id="element-1089" />
                              <div className="w-full h-3 bg-slate-200 rounded mb-2" data-id="element-1090" />
                              <div className="w-2/3 h-3 bg-slate-200 rounded mx-auto" data-id="element-1091" />
                              <div className="mt-3 text-[10px]" data-id="element-1092">
                                Основной контент страницы
                              </div>
                            </div>
                          </div>
                          <div className="w-[300px] shrink-0" data-id="element-1093">
                            <AdSlot slotId={s.id} onNavigate={mockHandler} showDebug data-id="element-1094" />
                          </div>
                        </div> : isCard ? <div className="grid grid-cols-3 gap-3" data-id="element-1095">
                          <div className="bg-slate-50 rounded-lg p-4 flex items-center justify-center h-24" data-id="element-1096">
                            <span className="text-[10px] text-slate-300" data-id="element-1097">
                              Карточка
                            </span>
                          </div>
                          <div className="col-span-2" data-id="element-1098">
                            <AdSlot slotId={s.id} onNavigate={mockHandler} showDebug data-id="element-1099" />
                          </div>
                          <div className="bg-slate-50 rounded-lg p-4 flex items-center justify-center h-24" data-id="element-1100">
                            <span className="text-[10px] text-slate-300" data-id="element-1101">
                              Карточка
                            </span>
                          </div>
                        </div> : <div className="space-y-3" data-id="element-1102">
                          <div className="flex gap-3" data-id="element-1103">
                            <div className="h-3 bg-slate-100 rounded flex-1" data-id="element-1104" />
                            <div className="h-3 bg-slate-100 rounded w-1/4" data-id="element-1105" />
                          </div>
                          <AdSlot slotId={s.id} onNavigate={mockHandler} showDebug data-id="element-1106" />
                          <div className="flex gap-3" data-id="element-1107">
                            <div className="h-3 bg-slate-100 rounded w-2/3" data-id="element-1108" />
                            <div className="h-3 bg-slate-100 rounded flex-1" data-id="element-1109" />
                          </div>
                        </div>}
                    </div>

                    {/* Stats grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-5 gap-3" data-id="element-1110">
                      <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1111">
                        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1112">
                          Цена
                        </div>
                        <div className="text-sm font-bold text-slate-900" data-id="element-1113">
                          {s.basePrice?.toLocaleString()}₽
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1114">
                        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1115">
                          Лимит
                        </div>
                        <div className="text-sm font-bold text-slate-900" data-id="element-1116">
                          {s.limit} мест
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1117">
                        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1118">
                          Активных
                        </div>
                        <div className="text-sm font-bold text-emerald-600" data-id="element-1119">
                          {s.active}
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1120">
                        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1121">
                          В очереди
                        </div>
                        <div className="text-sm font-bold text-amber-600" data-id="element-1122">
                          {s.queued}
                        </div>
                      </div>
                      <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1123">
                        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1124">
                          Fill rate
                        </div>
                        <div className="text-sm font-bold text-indigo-600" data-id="element-1125">
                          {s.fillRate}%
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="p-4 border-t border-slate-200 bg-white flex justify-end gap-3 shrink-0" data-id="element-1126">
                    <Button variant="outline" onClick={() => setPreviewBanner(null)} data-id="element-1127">
                      Закрыть
                    </Button>
                    <Button variant="primary" icon={<Settings className="w-4 h-4" data-id="element-1129" />} onClick={() => {
                setPreviewBanner(null);
                setSlotDetailId(s.id);
              }} data-id="element-1128">
                      Настроить слот
                    </Button>
                  </div>
                </Card>
              </div>;
      })()}

        {/* Create Slot Modal */}
        {showCreateSlot && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1130">
            <Card className="w-full max-w-md shadow-2xl" data-id="element-1131">
              <div className="flex justify-between items-center mb-6" data-id="element-1132">
                <div data-id="element-1133">
                  <h3 className="text-lg font-bold text-slate-900" data-id="element-1134">
                    Новый слот
                  </h3>
                </div>
                <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1136" />} onClick={() => setShowCreateSlot(false)} data-id="element-1135" />
              </div>
              <div className="space-y-4 mb-6" data-id="element-1137">
                <div data-id="element-1138">
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5" data-id="element-1139">
                    Название
                  </label>
                  <input type="text" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" placeholder="Например: Сайдбар блога" data-id="element-1140" />
                </div>
                <div data-id="element-1141">
                  <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider mb-1.5" data-id="element-1142">
                    Тип слота
                  </label>
                  <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1143">
                    <option data-id="element-1144">Banner</option>
                    <option data-id="element-1145">Native</option>
                    <option data-id="element-1146">Pinned</option>
                    <option data-id="element-1147">Email</option>
                  </select>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg text-xs text-blue-800" data-id="element-1148">
                  После создания вы сможете настроить логику ротации, цены и
                  fallback в настройках Slot Engine.
                </div>
              </div>
              <div className="flex justify-end gap-3" data-id="element-1149">
                <Button variant="outline" onClick={() => setShowCreateSlot(false)} data-id="element-1150">
                  Отмена
                </Button>
                <Button variant="primary" onClick={() => {
              success('Слот создан');
              setShowCreateSlot(false);
            }} data-id="element-1151">
                  Создать
                </Button>
              </div>
            </Card>
          </div>}
      </div>;
  };
  const renderQueue = () => {
    return <AdQueueManager placements={placements} slotsData={slotsData} setDetailPanel={setDetailPanel} setShowDeleteConfirm={setShowDeleteConfirm} moveQueueItem={moveQueueItem} activateQueueItem={activateQueueItem} togglePlacementStatus={togglePlacementStatus} toggleFastTrack={toggleFastTrack} data-id="element-1152" />;
  };
  const renderFeaturedAstrologers = () => <FeaturedAstrologersManager astrologers={mockFeaturedAstrologers} setDetailPanel={setDetailPanel} success={success} setShowCreatePin={setShowCreatePin} data-id="element-1153" />;
  const renderFeaturedCourses = () => <FeaturedCoursesManager courses={mockFeaturedCourses} setDetailPanel={setDetailPanel} success={success} data-id="element-1154" />;
  const renderEmailCampaigns = () => <EmailCampaignsManager setDetailPanel={setDetailPanel} success={success} data-id="element-1155" />;
  return <div className="space-y-6" data-id="element-1156">
      <div className="flex justify-between items-center" data-id="element-1157">
        <div data-id="element-1158">
          <h2 className="text-xl font-bold text-slate-900" data-id="element-1159">
            Реклама и размещения
          </h2>
          <p className="text-sm text-slate-500" data-id="element-1160">
            Управление рекламой, слотами, очередью и email-кампаниями
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-1162" />} onClick={() => setShowCreatePlacement(true)} data-id="element-1161">
          Новое размещение
        </Button>
      </div>
      <Tabs activeTab={activeSubTab} onChange={setActiveSubTab} tabs={[{
      id: 'all',
      label: 'Все размещения'
    }, {
      id: 'slots',
      label: 'Слоты'
    }, {
      id: 'queue',
      label: 'Очередь'
    }, {
      id: 'featured_astrologers',
      label: 'Закреп астрологов'
    }, {
      id: 'featured_courses',
      label: 'Закреп курсов'
    }, {
      id: 'email',
      label: 'Email-рассылки'
    }, {
      id: 'analytics',
      label: 'Аналитика'
    }]} data-id="element-1163" />
      <div data-id="element-1164">
        {activeSubTab === 'all' && renderAllPlacements()}
        {activeSubTab === 'slots' && renderSlots()}
        {activeSubTab === 'queue' && renderQueue()}
        {activeSubTab === 'featured_astrologers' && renderFeaturedAstrologers()}
        {activeSubTab === 'featured_courses' && renderFeaturedCourses()}
        {activeSubTab === 'email' && <EmailCampaignsManager setDetailPanel={setDetailPanel} success={success} data-id="element-1165" />}
        {activeSubTab === 'analytics' && <AdAnalyticsDashboard placements={placements} slotsData={slotsData} setActiveTab={setActiveSubTab} setDetailPanel={setDetailPanel} success={success} data-id="element-1166" />}
      </div>

      {/* Mobile popover backdrop */}
      {activePopover && <div className="fixed inset-0 z-[55] bg-slate-900/30 backdrop-blur-[1px] sm:hidden" onClick={() => setActivePopover(null)} data-id="element-1167" />}

      {/* === GLOBAL MODALS === */}

      {/* Create Placement Modal */}
      {showCreatePlacement && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1168">
          <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-1169">
            <div className="flex justify-between items-center mb-6" data-id="element-1170">
              <div data-id="element-1171">
                <h3 className="text-lg font-bold text-slate-900" data-id="element-1172">
                  Новое размещение
                </h3>
                <p className="text-sm text-slate-500" data-id="element-1173">
                  Создайте новое рекламное размещение
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1175" />} onClick={() => setShowCreatePlacement(false)} data-id="element-1174" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-1176">
              <div data-id="element-1177">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1178">
                  Объект рекламы
                </label>
                <input type="text" placeholder="Название..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1179" />
              </div>
              <div data-id="element-1180">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1181">
                  Рекламодатель
                </label>
                <input type="text" placeholder="Компания..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1182" />
              </div>
              <div data-id="element-1183">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1184">
                  Слот
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1185">
                  <option value="" data-id="element-1186">Выберите слот...</option>
                  {slotsData.map(s => <option key={s.id} value={s.id} data-id="element-1187">
                      {s.name} ({s.active}/{s.limit} занято)
                    </option>)}
                </select>
              </div>
              <div data-id="element-1188">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1189">
                  Тип
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1190">
                  <option data-id="element-1191">Banner</option>
                  <option data-id="element-1192">Promo</option>
                  <option data-id="element-1193">Pinned astrologer</option>
                  <option data-id="element-1194">Pinned course</option>
                  <option data-id="element-1195">Email</option>
                  <option data-id="element-1196">Native article</option>
                </select>
              </div>
              <div data-id="element-1197">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1198">
                  Дата начала
                </label>
                <input type="date" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1199" />
              </div>
              <div data-id="element-1200">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1201">
                  Дата окончания
                </label>
                <input type="date" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1202" />
              </div>
              <div data-id="element-1203">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1204">
                  Цена (₽)
                </label>
                <input type="number" placeholder="0" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1205" />
              </div>
              <div data-id="element-1206">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1207">
                  Лимит показов
                </label>
                <input type="number" placeholder="50000" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1208" />
              </div>
              <div data-id="element-1209">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1210">
                  Приоритет (1-10)
                </label>
                <input type="number" min="1" max="10" placeholder="5" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1211" />
              </div>
              <div data-id="element-1212">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1213">
                  Оплата
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1214">
                  <option value="pending" data-id="element-1215">Ожидает оплаты</option>
                  <option value="paid" data-id="element-1216">Оплачено</option>
                </select>
              </div>
              <div className="md:col-span-2 flex items-center gap-3" data-id="element-1217">
                <label className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer" data-id="element-1218">
                  <input type="checkbox" className="rounded border-slate-300" data-id="element-1219" />
                  Автопродление
                </label>
                <label className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer" data-id="element-1220">
                  <input type="checkbox" className="rounded border-slate-300" data-id="element-1221" />
                  Fast Track (приоритетная очередь)
                </label>
              </div>
            </div>
            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-1222">
              <Button variant="outline" onClick={() => setShowCreatePlacement(false)} data-id="element-1223">
                Отмена
              </Button>
              <Button variant="primary" onClick={() => {
            setShowCreatePlacement(false);
            success('Размещение создано и добавлено в очередь');
          }} data-id="element-1224">
                Создать размещение
              </Button>
            </div>
          </Card>
        </div>}

      {/* Create Pin Modal (Astrologer / Course) */}
      {showCreatePin && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1225">
          <Card className="w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-1226">
            <div className="flex justify-between items-center mb-6" data-id="element-1227">
              <div data-id="element-1228">
                <h3 className="text-lg font-bold text-slate-900" data-id="element-1229">
                  {showCreatePin === 'astrologer' ? 'Закрепление астролога' : 'Закрепление курса'}
                </h3>
                <p className="text-sm text-slate-500" data-id="element-1230">
                  {showCreatePin === 'astrologer' ? 'Закрепите профиль астролога в топе каталога' : 'Закрепите курс в топе списка'}
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1232" />} onClick={() => setShowCreatePin(null)} data-id="element-1231" />
            </div>
            <div className="space-y-4 mb-6" data-id="element-1233">
              <div data-id="element-1234">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1235">
                  {showCreatePin === 'astrologer' ? 'Астролог' : 'Курс'}
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1236">
                  <option value="" data-id="element-1237">Выберите...</option>
                  {showCreatePin === 'astrologer' ? <>
                      <option data-id="element-1238">Мария Звёздная</option>
                      <option data-id="element-1239">Алексей Лунный</option>
                      <option data-id="element-1240">Ольга Солнцева</option>
                    </> : <>
                      <option data-id="element-1241">Натальная астрология</option>
                      <option data-id="element-1242">Курс Таро</option>
                      <option data-id="element-1243">Транзиты и прогнозы</option>
                    </>}
                </select>
              </div>
              <div data-id="element-1244">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1245">
                  Позиция
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1246">
                  <option data-id="element-1247">ТОП-1</option>
                  <option data-id="element-1248">ТОП-2</option>
                  <option data-id="element-1249">ТОП-3</option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-3" data-id="element-1250">
                <div data-id="element-1251">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1252">
                    Дата начала
                  </label>
                  <input type="date" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1253" />
                </div>
                <div data-id="element-1254">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1255">
                    Дата окончания
                  </label>
                  <input type="date" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1256" />
                </div>
              </div>
              <div data-id="element-1257">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1258">
                  Цена (₽)
                </label>
                <input type="number" placeholder="15000" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1259" />
              </div>
            </div>
            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-1260">
              <Button variant="outline" onClick={() => setShowCreatePin(null)} data-id="element-1261">
                Отмена
              </Button>
              <Button variant="primary" onClick={() => {
            setShowCreatePin(null);
            success(showCreatePin === 'astrologer' ? 'Закрепление астролога создано' : 'Закрепление курса создано');
          }} data-id="element-1262">
                Создать
              </Button>
            </div>
          </Card>
        </div>}

      {/* Create Email Campaign Modal */}
      {showCreateCampaign && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1263">
          <Card className="w-full max-w-lg max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-1264">
            <div className="flex justify-between items-center mb-6" data-id="element-1265">
              <div data-id="element-1266">
                <h3 className="text-lg font-bold text-slate-900" data-id="element-1267">
                  Новая email-кампания
                </h3>
                <p className="text-sm text-slate-500" data-id="element-1268">
                  Создайте рекламную email-рассылку
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1270" />} onClick={() => setShowCreateCampaign(false)} data-id="element-1269" />
            </div>
            <div className="space-y-4 mb-6" data-id="element-1271">
              <div data-id="element-1272">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1273">
                  Название кампании
                </label>
                <input type="text" placeholder="Весенняя акция..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1274" />
              </div>
              <div data-id="element-1275">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1276">
                  Тема письма
                </label>
                <input type="text" placeholder="Тема..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1277" />
              </div>
              <div data-id="element-1278">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1279">
                  Аудитория
                </label>
                <select className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1280">
                  <option data-id="element-1281">Все подписчики</option>
                  <option data-id="element-1282">Активные пользователи</option>
                  <option data-id="element-1283">Премиум пользователи</option>
                  <option data-id="element-1284">Неактивные (30+ дней)</option>
                </select>
              </div>
              <div data-id="element-1285">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1286">
                  Дата отправки
                </label>
                <input type="date" className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1287" />
              </div>
              <div data-id="element-1288">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1289">
                  Содержание
                </label>
                <textarea rows={3} placeholder="Текст рассылки..." className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-id="element-1290" />
              </div>
            </div>
            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-1291">
              <Button variant="outline" onClick={() => setShowCreateCampaign(false)} data-id="element-1292">
                Отмена
              </Button>
              <Button variant="primary" onClick={() => {
            setShowCreateCampaign(false);
            success('Email-кампания создана');
          }} data-id="element-1293">
                Создать кампанию
              </Button>
            </div>
          </Card>
        </div>}

      {/* Placement Preview Modal (from "Все размещения" tab) */}
      {previewBanner && !previewBanner.type && (() => {
      const p = previewBanner;
      const slotId = p.slot || '';
      const slotConfig = ALL_AD_SLOTS.find((s: any) => s.id === slotId);
      const isSidebar = slotConfig?.size === '300×600' || slotConfig?.size === '300×250';
      const isCard = slotConfig?.size === 'Карточка';
      return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1294">
              <Card className="w-full max-w-3xl shadow-2xl max-h-[90vh] flex flex-col" padding="none" data-id="element-1295">
                <div className="p-5 border-b border-slate-200 flex justify-between items-start shrink-0" data-id="element-1296">
                  <div data-id="element-1297">
                    <div className="flex items-center gap-3 mb-1" data-id="element-1298">
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-1299">
                        {p.object}
                      </h3>
                      <Badge variant={p.status === 'active' ? 'success' : p.status === 'paused' ? 'warning' : 'neutral'} size="sm" data-id="element-1300">
                        {p.status === 'active' ? 'Активно' : p.status === 'paused' ? 'Пауза' : p.status === 'completed' ? 'Завершено' : p.status === 'queued' ? 'В очереди' : p.status}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-1301">
                      <span className="font-mono text-xs px-2 py-0.5 bg-indigo-50 text-indigo-600 rounded font-bold" data-id="element-1302">
                        {slotId}
                      </span>
                      <span data-id="element-1303">{p.slotName}</span>
                      <span data-id="element-1304">•</span>
                      <span data-id="element-1305">{p.advertiser}</span>
                    </div>
                  </div>
                  <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1307" />} onClick={() => setPreviewBanner(null)} data-id="element-1306" />
                </div>

                <div className="flex-1 overflow-y-auto p-5 space-y-5 bg-slate-50" data-id="element-1308">
                  {/* Live AdSlot preview */}
                  <div className="rounded-xl border-2 border-dashed border-slate-300 bg-white p-6" data-id="element-1309">
                    <div className="text-[10px] font-bold text-emerald-600 uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-1310">
                      <Eye className="w-3.5 h-3.5" data-id="element-1311" />
                      Живое превью баннера на сайте
                    </div>
                    <div className={isSidebar ? 'max-w-[320px]' : isCard ? 'max-w-md' : 'w-full'} data-id="element-1312">
                      <AdSlot slotId={slotId} onNavigate={() => success('Клик по баннеру (превью)')} showDebug data-id="element-1313" />
                    </div>
                    {!slotConfig && <div className="text-center py-8 text-slate-400" data-id="element-1314">
                        <Layers className="w-8 h-8 mx-auto mb-2 opacity-50" data-id="element-1315" />
                        <div className="text-sm" data-id="element-1316">Слот {slotId} не найден</div>
                      </div>}
                  </div>

                  {/* Placement stats */}
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-1317">
                    <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1318">
                      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1319">
                        Показы
                      </div>
                      <div className="text-sm font-bold text-slate-900" data-id="element-1320">
                        {(p.impressionsFact || 0).toLocaleString()} /{' '}
                        {(p.impressionsPlan || 0).toLocaleString()}
                      </div>
                      {p.impressionsPlan > 0 && <div className="mt-1.5 w-full bg-slate-100 rounded-full h-1.5" data-id="element-1321">
                          <div className="bg-indigo-500 h-1.5 rounded-full" style={{
                    width: `${Math.min(100, (p.impressionsFact || 0) / p.impressionsPlan * 100)}%`
                  }} data-id="element-1322" />
                        </div>}
                    </div>
                    <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1323">
                      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1324">
                        Клики
                      </div>
                      <div className="text-sm font-bold text-slate-900" data-id="element-1325">
                        {(p.clicks || 0).toLocaleString()}
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1326">
                      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1327">
                        CTR
                      </div>
                      <div className="text-sm font-bold text-indigo-600" data-id="element-1328">
                        {p.ctr || '0%'}
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-3 border border-slate-200" data-id="element-1329">
                      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-1330">
                        Стоимость
                      </div>
                      <div className="text-sm font-bold text-slate-900" data-id="element-1331">
                        {formatCurrency(p.price)}
                      </div>
                    </div>
                  </div>

                  {/* Period & details */}
                  <div className="bg-white rounded-lg p-4 border border-slate-200" data-id="element-1332">
                    <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-1333">
                      <div data-id="element-1334">
                        <span className="text-slate-500" data-id="element-1335">Период:</span>
                        <span className="ml-2 font-medium text-slate-900" data-id="element-1336">
                          {p.periodStart} — {p.periodEnd}
                        </span>
                      </div>
                      <div data-id="element-1337">
                        <span className="text-slate-500" data-id="element-1338">Таймер:</span>
                        <span className="ml-2 font-medium text-slate-900" data-id="element-1339">
                          {p.timer}
                        </span>
                      </div>
                      <div data-id="element-1340">
                        <span className="text-slate-500" data-id="element-1341">Тип:</span>
                        <span className="ml-2 font-medium text-slate-900" data-id="element-1342">
                          {p.type} • {p.objectType}
                        </span>
                      </div>
                      <div data-id="element-1343">
                        <span className="text-slate-500" data-id="element-1344">Оплата:</span>
                        <span className={`ml-2 font-medium ${p.payment === 'paid' ? 'text-emerald-600' : 'text-amber-600'}`} data-id="element-1345">
                          {p.payment === 'paid' ? 'Оплачено' : 'Ожидает оплаты'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-4 border-t border-slate-200 bg-white flex justify-between items-center shrink-0" data-id="element-1346">
                  <div className="flex gap-2" data-id="element-1347">
                    {p.status === 'active' && <Button variant="outline" icon={<Pause className="w-4 h-4" data-id="element-1349" />} onClick={() => {
                togglePlacementStatus(p.id, 'paused');
                setPreviewBanner(null);
              }} data-id="element-1348">
                        Остановить
                      </Button>}
                    {p.status === 'paused' && <Button variant="outline" icon={<Play className="w-4 h-4" data-id="element-1351" />} onClick={() => {
                togglePlacementStatus(p.id, 'active');
                setPreviewBanner(null);
              }} data-id="element-1350">
                        Запустить
                      </Button>}
                  </div>
                  <div className="flex gap-3" data-id="element-1352">
                    <Button variant="outline" onClick={() => setPreviewBanner(null)} data-id="element-1353">
                      Закрыть
                    </Button>
                    <Button variant="primary" icon={<Edit className="w-4 h-4" data-id="element-1355" />} onClick={() => {
                setPreviewBanner(null);
                setEditingPlacement(p);
              }} data-id="element-1354">
                      Редактировать
                    </Button>
                  </div>
                </div>
              </Card>
            </div>;
    })()}

      {/* Global Delete Confirmation */}
      {showDeleteConfirm && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1356">
          <Card className="w-full max-w-sm shadow-2xl text-center" data-id="element-1357">
            <div className="w-12 h-12 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mx-auto mb-4" data-id="element-1358">
              <AlertTriangle className="w-6 h-6" data-id="element-1359" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1360">
              Подтвердите удаление
            </h3>
            <p className="text-sm text-slate-500 mb-6" data-id="element-1361">
              Вы уверены, что хотите удалить размещение {showDeleteConfirm}? Это
              действие нельзя отменить.
            </p>
            <div className="flex justify-center gap-3" data-id="element-1362">
              <Button variant="outline" onClick={() => setShowDeleteConfirm(null)} data-id="element-1363">
                Отмена
              </Button>
              <Button variant="primary" className="bg-rose-600 hover:bg-rose-700" onClick={() => deletePlacement(showDeleteConfirm)} data-id="element-1364">
                Удалить
              </Button>
            </div>
          </Card>
        </div>}

      {/* Renewal Modal */}
      {showRenewModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1365">
          <Card className="w-full max-w-md shadow-2xl" data-id="element-1366">
            <div className="flex justify-between items-center mb-6" data-id="element-1367">
              <div data-id="element-1368">
                <h3 className="text-lg font-bold text-slate-900" data-id="element-1369">
                  Продлить размещение
                </h3>
                <p className="text-sm text-slate-500" data-id="element-1370">
                  {showRenewModal.id} — {showRenewModal.object}
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1372" />} onClick={() => setShowRenewModal(null)} data-id="element-1371" />
            </div>
            <div className="bg-slate-50 rounded-lg p-4 mb-4 space-y-2" data-id="element-1373">
              <div className="flex justify-between text-sm" data-id="element-1374">
                <span className="text-slate-500" data-id="element-1375">Текущий период:</span>
                <span className="font-medium text-slate-900" data-id="element-1376">
                  {showRenewModal.periodStart} — {showRenewModal.periodEnd}
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-1377">
                <span className="text-slate-500" data-id="element-1378">Осталось:</span>
                <span className="font-bold text-slate-900" data-id="element-1379">
                  {showRenewModal.daysLeft} дней
                </span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-1380">
                <span className="text-slate-500" data-id="element-1381">Цена:</span>
                <span className="font-bold text-slate-900" data-id="element-1382">
                  {formatCurrency(showRenewModal.price)}
                </span>
              </div>
            </div>
            <div className="space-y-4" data-id="element-1383">
              <div data-id="element-1384">
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-1385">
                  На сколько продлить?
                </label>
                <div className="grid grid-cols-4 gap-2" data-id="element-1386">
                  {[7, 14, 30, 90].map(d => <button key={d} className="px-3 py-2 rounded-lg border border-slate-200 text-sm font-medium hover:bg-indigo-50 hover:border-indigo-300 hover:text-indigo-700 transition-colors focus:ring-2 focus:ring-indigo-500 focus:outline-none" onClick={() => renewPlacement(showRenewModal.id, d)} data-id="element-1387">
                      {d} дней
                    </button>)}
                </div>
              </div>
              <div className="flex justify-end pt-2" data-id="element-1388">
                <Button variant="outline" onClick={() => setShowRenewModal(null)} data-id="element-1389">
                  Отмена
                </Button>
              </div>
            </div>
          </Card>
        </div>}

      {/* Stats Panel Modal */}
      {showStatsPanel && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-1390">
          <Card className="w-full max-w-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-1391">
            <div className="flex justify-between items-center mb-6" data-id="element-1392">
              <div data-id="element-1393">
                <h3 className="text-lg font-bold text-slate-900" data-id="element-1394">
                  Статистика: {showStatsPanel.object}
                </h3>
                <p className="text-sm text-slate-500" data-id="element-1395">
                  {showStatsPanel.id} • {showStatsPanel.slotName} •{' '}
                  {showStatsPanel.periodStart} — {showStatsPanel.periodEnd}
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<X className="w-5 h-5" data-id="element-1397" />} onClick={() => setShowStatsPanel(null)} data-id="element-1396" />
            </div>

            {/* KPI Row */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-1398">
              <div className="bg-blue-50 rounded-xl p-3 text-center" data-id="element-1399">
                <div className="text-xs text-blue-600 font-medium mb-1" data-id="element-1400">
                  Показы
                </div>
                <div className="text-xl font-bold text-blue-900" data-id="element-1401">
                  {showStatsPanel.impressionsFact.toLocaleString()}
                </div>
                <div className="text-[10px] text-blue-500" data-id="element-1402">
                  из {showStatsPanel.impressionsPlan.toLocaleString()}
                </div>
              </div>
              <div className="bg-purple-50 rounded-xl p-3 text-center" data-id="element-1403">
                <div className="text-xs text-purple-600 font-medium mb-1" data-id="element-1404">
                  Клики
                </div>
                <div className="text-xl font-bold text-purple-900" data-id="element-1405">
                  {showStatsPanel.clicks.toLocaleString()}
                </div>
              </div>
              <div className="bg-indigo-50 rounded-xl p-3 text-center" data-id="element-1406">
                <div className="text-xs text-indigo-600 font-medium mb-1" data-id="element-1407">
                  CTR
                </div>
                <div className="text-xl font-bold text-indigo-900" data-id="element-1408">
                  {showStatsPanel.ctr}
                </div>
              </div>
              <div className="bg-emerald-50 rounded-xl p-3 text-center" data-id="element-1409">
                <div className="text-xs text-emerald-600 font-medium mb-1" data-id="element-1410">
                  Доход
                </div>
                <div className="text-xl font-bold text-emerald-900" data-id="element-1411">
                  {formatCurrency(showStatsPanel.price)}
                </div>
              </div>
            </div>

            {/* Impressions Progress */}
            <div className="mb-6" data-id="element-1412">
              <div className="flex justify-between text-sm mb-2" data-id="element-1413">
                <span className="font-bold text-slate-900" data-id="element-1414">
                  Прогресс показов
                </span>
                <span className="text-slate-500" data-id="element-1415">
                  {Math.round(showStatsPanel.impressionsFact / showStatsPanel.impressionsPlan * 100)}
                  %
                </span>
              </div>
              <div className="w-full bg-slate-100 rounded-full h-3" data-id="element-1416">
                <div className={`h-3 rounded-full transition-all ${showStatsPanel.impressionsFact / showStatsPanel.impressionsPlan >= 0.95 ? 'bg-rose-500' : showStatsPanel.impressionsFact / showStatsPanel.impressionsPlan >= 0.8 ? 'bg-amber-500' : 'bg-indigo-500'}`} style={{
              width: `${Math.min(100, showStatsPanel.impressionsFact / showStatsPanel.impressionsPlan * 100)}%`
            }} data-id="element-1417" />
              </div>
              {showStatsPanel.impressionsFact / showStatsPanel.impressionsPlan >= 0.95 && <div className="flex items-center gap-1 mt-2 text-xs text-rose-600 font-medium" data-id="element-1418">
                  <AlertTriangle className="w-3 h-3" data-id="element-1419" /> Близко к лимиту показов!
                </div>}
            </div>

            {/* Daily Chart (mock) */}
            <div className="mb-6" data-id="element-1420">
              <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-1421">
                Показы по дням (последние 7 дней)
              </h4>
              <div className="flex items-end gap-1 h-24" data-id="element-1422">
                {[65, 78, 92, 85, 110, 95, 88].map((v, i) => <div key={i} className="flex-1 flex flex-col items-center gap-1" data-id="element-1423">
                    <div className="w-full bg-indigo-400 rounded-t hover:bg-indigo-500 transition-colors cursor-pointer" style={{
                height: `${v / 110 * 80}px`
              }} title={`${v * 50} показов`} data-id="element-1424" />
                    <span className="text-[9px] text-slate-400" data-id="element-1425">
                      {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'][i]}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Details Table */}
            <div className="mb-6" data-id="element-1426">
              <h4 className="text-sm font-bold text-slate-900 mb-3" data-id="element-1427">
                Детали размещения
              </h4>
              <div className="bg-slate-50 rounded-lg divide-y divide-slate-200" data-id="element-1428">
                {[['Рекламодатель', showStatsPanel.advertiser], ['Тип', showStatsPanel.type], ['Статус', placementStatusConfig[showStatsPanel.status]?.label || showStatsPanel.status], ['Причина статуса', statusReasonConfig[showStatsPanel.statusReason]?.label || showStatsPanel.statusReason], ['Приоритет', `${showStatsPanel.priority}/10`], ['Оплата', showStatsPanel.payment === 'paid' ? 'Оплачено' : 'Ожидает'], ['Автопродление', showStatsPanel.autoRenew ? 'Включено' : 'Выключено'], ['Осталось дней', `${showStatsPanel.daysLeft}`]].map(([label, value], i) => <div key={i} className="flex justify-between px-4 py-2.5" data-id="element-1429">
                    <span className="text-xs text-slate-500" data-id="element-1430">{label}</span>
                    <span className="text-xs font-bold text-slate-900" data-id="element-1431">
                      {value}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-1432">
              <Button variant="outline" onClick={() => setShowStatsPanel(null)} data-id="element-1433">
                Закрыть
              </Button>
              <Button variant="primary" onClick={() => {
            setShowStatsPanel(null);
            setEditingPlacement(showStatsPanel);
          }} data-id="element-1434">
                Редактировать
              </Button>
            </div>
          </Card>
        </div>}
    </div>;
}